import React, { useState, useEffect } from "react";
import {
  FaBook,
  FaPenFancy,
  FaHospital,
  FaTools,
  FaCheck,
} from "react-icons/fa";
import { FcDepartment } from "react-icons/fc";
import "../style/InstituteOnBoarding.css";
import { validationRules } from "../validations/Validation";
import {
  getStates,
  fetchDistrictsByState,
  fetchTalukasByDistrict,
  getDepartment,
  getUniversity,
  getColleges,
  getPicklistByERC,
  creatingEntry,
  fetchVillagesByTaluka,
  checkEmailExists,
  checkAisheCode,
  fetchRegions,
  getAadhaarRefByAadhaar,
} from "../api/fetch-masters.js";
import Select from "react-select";
import { getUserRolesById } from "../api/userService.js";
import {
  checkValidFileAPI,
  createSanitizedFile,
  uploadAttachmentByFolderName,
} from "../api/upload.js";
import { useNavigate } from "react-router";
import EmailOTP from "../modal/EmailOTP";
import AadhaarOTP from "../modal/AadhaarOTP";
import MobileOTP from "../modal/MobileOTP";
import { verifyEmailOTP } from "../api/verify-otp.js";
const siteId = window.Liferay?.ThemeDisplay?.getScopeGroupId();


const uploadMultipleFiles = async (filesArray) => {
  if (!filesArray || filesArray.length === 0) return [];

  const uploadedDocs = await Promise.all(
    filesArray.map((file) =>
      uploadAttachmentByFolderName(siteId, file, "Institute Documents"),
    ),
  );

  return uploadedDocs;
};
/* =========================
  MAIN COMPONENT
========================= */
const InstituteOnBoarding = () => {
  const [step, setStep] = useState(1);
  const [departmentsList, setDepartmentsList] = useState([]);
  const navigate = useNavigate();


  const initialFormData = {
    parentDepartmentId: null,
    parentDepartment: "",
    deptCode: "",
    aisheCode: "",
    instituteName: "",
    departmentCode: "",
    stateId: null,
    state: "Maharashtra",
    districtId: null,
    district: "",
    talukaId: null,
    taluka: "",
    villageId: null,
    village: "",
    pincode: "",
    address: "",

    website: "",
    stdCode: "",
    email: "",
    phone: "",

    instituteType: "",
    regNumber: "",
    establishYear: "",

    naacAccredited: null,
    underAdministration: null,
    university: "",
    instituteUnder: "",
    instituteRegionID: "",
    mahaDbtCode: "",

    outsideMaharashtra: false,
    aicteApprovalFiles: [],
    authorizationLetterFiles: [],
    aisheCertificateFiles: [],
    courseAffiliationLetterFiles: [],
    governmentPermissionFiles: [],
    aadhaarNumber: "",
    creatorUserName: "",
    mobieleNumber: "",
    emailVerified: false,
    aadhaarVerified: false,
    mobileVerified: false,
  };
  const nextStep = () => setStep((p) => p + 1);
  const prevStep = () => setStep((p) => p - 1);

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const department = await getDepartment();
        const mappedDepartments = department.map((dept) => ({
          id: dept.id,
          name: dept.name,
          code: dept.code,
          departmentId: dept.departmentId,
        }));

        setDepartmentsList(mappedDepartments);
      } catch (error) {
        console.error("Failed to fetch departments:", error);
      }
    };

    fetchDepartments();
  }, []);

  const [formData, setFormData] = useState(initialFormData);

  const [emailVerification, setEmailVerification] = useState({
    show: false,
    verified: false,
    email: "",
    verifiedEmail: "",
  });

  const [aadhaarVerification, setAadhaarVerification] = useState({
    show: false,
    verified: false,
    aadhaarnumber: "",
    verifiedAadhaar: "",
    verifyName: false,
  });

  const [mobileNumberVerification, setMobileNumberVerification] = useState({
    show: false,
    verified: false,
    mobileNumber: "",
    verifiedMobileNumber: "",
  });

  return (
    <div className="container my-4">
      <div className="card shadow-lg border-0 mb-4">
        <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center py-3">
          <h5 className="mb-0 fw-semibold">
            <i className="fas fa-university me-2"></i>
            Institute Registration
          </h5>

          <button
            className="btn btn-sm fw-semibold"
            style={{
              color: "#ffffff",
            }}
            onClick={() => navigate("/")}
          >
            ← Back
          </button>
        </div>
      </div>
      {step < 3 && <RegistrationProgress step={step} />}

      {step === 1 && (
        <InstituteDetails
          formData={formData}
          setFormData={setFormData}
          nextStep={nextStep}
          prevStep={prevStep}
          departmentsList={departmentsList}
          setDepartmentsList={setDepartmentsList}
          emailVerification={emailVerification}
          setEmailVerification={setEmailVerification}

          aadhaarVerification={aadhaarVerification}
          setAadhaarVerification={setAadhaarVerification}

          mobileNumberVerification={mobileNumberVerification}
          setMobileNumberVerification={setMobileNumberVerification}
        />
      )}

      {step === 2 && <ReviewSubmit formData={formData} prevStep={prevStep} />}
    </div>
  );
};

export default InstituteOnBoarding;

/* =========================
  REGISTRATION PROGRESS
========================= */
const RegistrationProgress = ({ step }) => {
  const steps = ["Institute Details", "Review & Submit"];
  const currentStep = Math.min(step, 2);

  return (
    <div className="card p-4 mb-4">
      <h5 className="mb-4">Registration Progress</h5>

      <div className="progress-container">
        {steps.map((label, index) => {
          const stepNumber = index + 1;
          const isCompleted = currentStep > stepNumber;
          const isActive = currentStep === stepNumber;

          return (
            <div className="progress-step" key={stepNumber}>
              <div
                className={`step-circle
                    ${isCompleted ? "completed" : ""}
                    ${isActive ? "active" : ""}
                  `}
              >
                {isCompleted ? <FaCheck size={12} /> : stepNumber}
              </div>
              <span className="step-label">{label}</span>
              {stepNumber !== steps.length && (
                <div
                  className={`step-line ${currentStep > stepNumber ? "line-completed" : ""}`}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

/* =========================
  STEP 1 – INSTITUTE FORM
========================= */
const InstituteDetails = ({
  formData,
  setFormData,
  nextStep,
  prevStep,
  departmentsList,
  setDepartmentsList,

  emailVerification,
  setEmailVerification,

  aadhaarVerification,
  setAadhaarVerification,

  mobileNumberVerification,
  setMobileNumberVerification,
}) => {
  const [statesList, setStatesList] = useState([]);
  const [districtsList, setDistrictsList] = useState([]);
  const [talukasList, setTalukasList] = useState([]);
  const [universitiesList, setUniversitiesList] = useState([]);
  const [instituteTypesList, setInstituteTypesList] = useState([]);
  const [regionsList, setRegionsList] = useState([]);
  const [instituteUnderList, setInstituteUnderList] = useState([]);
  const [villagesList, setVillagesList] = useState([]);
  const [errors, setErrors] = useState({});
  const maxFileSizeBytes = 5 * 1024 * 1024;
  // const [emailChecking, setEmailChecking] = useState(false);
  const [exists, setExists] = useState(false);
  const [checkingEmail, setCheckingEmail] = useState(false);
  const [showConsentModal, setShowConsentModal] = useState(false);
  const [consentChecked, setConsentChecked] = useState(false);
  const maskAadhaar = (aadhaar) => {
    if (!aadhaar || aadhaar.length !== 12) return aadhaar;

    return `XXXX XXXX ${aadhaar.slice(-4)}`;
  };
  const maskAadhaarNumber = (aadhaar) => {
    if (!aadhaar) return "";

    const clean = aadhaar.replace(/\D/g, ""); // remove non-digits
    if (clean.length !== 12) return aadhaar; // optional validation

    const last4 = clean.slice(-4);
    const masked = "XXXXXXXX" + last4;

    // format like XXXX XXXX 1234 (optional)
    return masked.replace(/(.{4})/g, "$1 ").trim();
  };

  const [showMaskedAadhaar, setShowMaskedAadhaar] = useState(false);

  const getInputClass = (field) =>
    `form-control ${errors[field] ? "is-invalid" : ""}`;

  const sanitizeFieldValue = (name, value) => {
    if (typeof value !== "string") return value;

    switch (name) {
      case "deptCode":
      case "regNumber":
        return value.replace(/[^A-Za-z0-9]/g, "");
      case "aisheCode":
        return value.replace(/[^A-Za-z0-9-]/g, "").slice(0, 7);
      case "address":
        return value.replace(/[^A-Za-z0-9\s,./#()-]/g, "");
      case "instituteName":
      case "creatorUserName":
        return value.replace(/[^A-Za-z\s]/g, "");
      case "pincode":
        return value.replace(/\D/g, "").slice(0, 6);
      case "stdCode":
        return value.replace(/\D/g, "").slice(0, 5);
      case "phone":
        return value.replace(/\D/g, "").slice(0, 8);
      case "website":
        return value.replace(/[^A-Za-z0-9@:/.?&=%-]/g, "");
      default:
        return value;
    }
  };

  const getPicklistLabel = (item) => {
    const name = item?.name;
    if (typeof name === "string") return name;
    if (name && typeof name === "object") {
      return name.en_US || name["en_US"] || Object.values(name)[0] || "";
    }
    return item?.key || "";
  };

  const sortByName = (data = []) => {
    return [...data].sort((a, b) =>
      (a.name || "").localeCompare(b.name || "", undefined, {
        sensitivity: "base",
      })
    );
  };

  // Fetch States on mount
  useEffect(() => {
    const fetchAllStates = async () => {
      const states = await getStates();
      const sortedStates = sortByName(states);
      setStatesList(sortedStates);
      // setStatesList(states);
      const maha = states.find(
        (s) => s.name.toLowerCase() === "maharashtra"
      );

      if (maha) {
        setFormData((prev) => ({
          ...prev,
          state: maha.name,
          stateId: maha.id,
        }));
      }
    };
    fetchAllStates();
    document.querySelectorAll("input").forEach((input) => {
      input.setAttribute("autocomplete", "off");
    });
  }, []);

  useEffect(() => {
    if (!formData.state) {
      setDistrictsList([]);
      return;
    }

    const loadDistricts = async () => {
      const selectedState = statesList.find((s) => s.name === formData.state);
      if (!selectedState) return;

      const districts = await fetchDistrictsByState(selectedState.id);
      setDistrictsList(sortByName(districts));
    };

    loadDistricts();
  }, [formData.state, statesList]);

  useEffect(() => {
    if (!formData.taluka) {
      setVillagesList([]);
      return;
    }

    const loadVillages = async () => {
      const selectedTaluka = talukasList.find(
        (t) => t.name === formData.taluka,
      );
      if (!selectedTaluka) return;

      const villages = await fetchVillagesByTaluka(selectedTaluka.id);
      setVillagesList(sortByName(villages));
    };

    loadVillages();
  }, [formData.taluka, talukasList]);

  useEffect(() => {
    if (!formData.district) {
      setTalukasList([]);
      return;
    }

    const loadTalukas = async () => {
      const selectedDistrict = districtsList.find(
        (d) => d.name === formData.district,
      );
      if (!selectedDistrict) return;

      const talukas = await fetchTalukasByDistrict(selectedDistrict.id);
      setTalukasList(sortByName(talukas));
    };

    loadTalukas();
  }, [formData.district, districtsList]);

  useEffect(() => {
    const fetchUniversities = async () => {
      try {
        const universities = await getUniversity();
        // setUniversitiesList(universities);
        setUniversitiesList(sortByName(universities));
      } catch (err) {
        console.error("Failed to fetch universities", err);
      }
    };

    const fetchUniRegions = async () => {
      try {
        const regions = await fetchRegions();
        setRegionsList(sortByName(regions));
      } catch (err) {
        console.error("Failed to fetch universities", err);
      }
    };
    fetchUniversities();
    fetchUniRegions();
  }, []);

  useEffect(() => {
    const fetchPicklists = async () => {
      try {
        const [types, instituteUnder] = await Promise.all([
          getPicklistByERC("INSTITUTE_TYPE_01"),
          getPicklistByERC("IS_INSTITUTE_UNDER_01"),
        ]);

        // setInstituteTypesList(types);
        // setInstituteUnderList(instituteUnder);
        setInstituteTypesList(sortByName(types));
        setInstituteUnderList(sortByName(instituteUnder));
      } catch (err) {
        console.error("Failed to fetch picklists", err);
      }
    };

    fetchPicklists();
  }, []);

  const normalizeState = (value = "") =>
    typeof value === "string" ? value.trim().toLowerCase() : "";

  useEffect(() => {
    if (normalizeState(formData.state) === "maharashtra") {
      setFormData((prev) => ({
        ...prev,
        outsideMaharashtra: false,
      }));

      setErrors((prev) => ({
        ...prev,
        outsideMaharashtra: "",
      }));
    }
  }, [formData.state]);

  // const handleFileUpload = (e) => {
  //   const { name, files } = e.target;
  //   const newFiles = Array.from(files);

  //   const invalidFile = newFiles.find((file) => {
  //     const isPdf =
  //       file.type === "application/pdf" ||
  //       String(file.name || "").toLowerCase().endsWith(".pdf");

  //     return !isPdf || file.size > maxFileSizeBytes;
  //   });

  //   if (invalidFile) {
  //     setErrors((prev) => ({
  //       ...prev,
  //       [name]: "Only PDF files up to 5 MB are allowed.",
  //     }));
  //     e.target.value = "";
  //     return;
  //   }

  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: [...(prev[name] || []), ...newFiles],
  //   }));

  //   setErrors((prev) => ({
  //     ...prev,
  //     [name]: "",
  //   }));

  //   e.target.value = "";
  // };

  // const handleFileUpload = (e) => {
  const handleFileUpload = async (e) => {
    const { name, files } = e.target;
    const newFiles = Array.from(files);

    for (const file of newFiles) {
      const isPdf =
        file.type === "application/pdf" ||
        String(file.name || "").toLowerCase().endsWith(".pdf");

      if (!isPdf) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Please upload a PDF file only.",
        }));
        e.target.value = "";
        return;
      }

      if (file.size > maxFileSizeBytes) {
        const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
        setErrors((prev) => ({
          ...prev,
          [name]: `File size must be less than 5MB. Current size: ${fileSizeMB}MB`,
        }));
        e.target.value = "";
        return;
      }
    }

    for (const file of newFiles) {
      const isValidFile = await checkValidFileAPI(file);

      if (!isValidFile) {
        setErrors((prev) => ({
          ...prev,
          [name]:
            "File validation failed. The uploaded file may be corrupted or malicious.",
        }));
        e.target.value = "";
        return;
      }
    }

    const sanitizedFiles = newFiles
      .map((file) => createSanitizedFile(file))
      .filter(Boolean);

    setFormData((prev) => ({
      ...prev,
      [name]: [...(prev[name] || []), ...sanitizedFiles],
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    e.target.value = "";
  };
  const handleRemoveFile = (fieldName, index) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: prev[fieldName].filter((_, i) => i !== index),
    }));

    setErrors((prev) => ({
      ...prev,
      [fieldName]:
        fieldName === "authorizationLetterFiles" &&
          formData.authorizationLetterFiles?.length === 1
          ? "Authorization Letter is required"
          : fieldName === "aisheCertificateFiles" &&
            formData.aisheCertificateFiles?.length === 1
            ? "AISHE Certificate is required"
            : fieldName === "courseAffiliationLetterFiles" &&
              formData.courseAffiliationLetterFiles?.length === 1
              ? "College Course Affiliation Letter is required"
              : fieldName === "governmentPermissionFiles" &&
                formData.governmentPermissionFiles?.length === 1
                ? "Government Permission (GR) is required"
                : "",
    }));
  };


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    const finalValue =
      type === "checkbox" ? checked : sanitizeFieldValue(name, value);

    setFormData((prev) => ({
      ...prev,
      [name]: finalValue,
    }));

    // Just clear old error
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleRadioChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };



  const inv = [0, 4, 3, 2, 1, 5, 6, 7, 8, 9];
  // Verhoeff tables
  const d = [
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    [1, 2, 3, 4, 0, 6, 7, 8, 9, 5],
    [2, 3, 4, 0, 1, 7, 8, 9, 5, 6],
    [3, 4, 0, 1, 2, 8, 9, 5, 6, 7],
    [4, 0, 1, 2, 3, 9, 5, 6, 7, 8],
    [5, 9, 8, 7, 6, 0, 4, 3, 2, 1],
    [6, 5, 9, 8, 7, 1, 0, 4, 3, 2],
    [7, 6, 5, 9, 8, 2, 1, 0, 4, 3],
    [8, 7, 6, 5, 9, 3, 2, 1, 0, 4],
    [9, 8, 7, 6, 5, 4, 3, 2, 1, 0]
  ];

  const p = [
    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    [1, 5, 7, 6, 2, 8, 3, 0, 9, 4],
    [5, 8, 0, 3, 7, 9, 6, 1, 4, 2],
    [8, 9, 1, 6, 0, 4, 3, 5, 2, 7],
    [9, 4, 5, 3, 1, 2, 6, 8, 7, 0],
    [4, 2, 8, 6, 5, 7, 3, 9, 0, 1],
    [2, 7, 9, 3, 8, 0, 6, 4, 1, 5],
    [7, 0, 4, 6, 9, 1, 3, 2, 5, 8]
  ];

  // Aadhaar validation using Verhoeff
  const validateAadhaarVerhoeff = (aadhaar) => {
    const value = aadhaar.replace(/\D/g, "");

    if (!/^[2-9][0-9]{11}$/.test(value)) return false;

    if (/^(\d)\1{11}$/.test(value)) return false;

    if (
      value === "123456789012" ||
      value === "012345678912"
    ) return false;

    let c = 0;
    const reversed = value.split("").reverse().map(Number);

    for (let i = 0; i < reversed.length; i++) {
      c = d[c][p[i % 8][reversed[i]]];
    }

    return c === 0;
  };
  const validateAadhaarField = (name, value) => {
    if (name === "aadhaarNumber") {
      if (!value) return "Aadhaar is required";

      if (value.length !== 12) return "Aadhaar must be 12 digits";

      if (!validateAadhaarVerhoeff(value)) {
        return "Invalid Aadhaar number";
      }

      return "";
    }

    return "";
  };

  const validateField = (name, value) => {
    const rule = validationRules[name];
    if (!rule) return "";

    const trimmedValue =
      typeof value === "string" ? value.trim() : value;

    const isEmptyValue =
      trimmedValue === "" ||
      trimmedValue === null ||
      trimmedValue === undefined;

    // Required check
    if (rule.required && isEmptyValue) {
      return rule.message;
    }

    if (name === "aadhaarNumber") {
      if (trimmedValue.length !== 12) {
        return "Aadhaar must be 12 digits";
      }

      if (!validateAadhaarVerhoeff(trimmedValue)) {
        return "Invalid Aadhaar number";
      }

      return "";
    }


    if (!rule.required && isEmptyValue) {
      return "";
    }

    if (typeof value === "string" && value.startsWith(" ")) {
      return "Leading spaces are not allowed";
    }

    if (rule.validations) {
      for (let v of rule.validations) {
        if (!v.pattern.test(trimmedValue)) {
          return v.message; // return first failed message
        }
      }
    }

    // fallback (old pattern support)
    if (rule.pattern && !rule.pattern.test(trimmedValue)) {
      return rule.message;
    }

    return "";
  };

  const validateForm = () => {
    const newErrors = {};

    Object.keys(validationRules).forEach((field) => {
      if (field === "mahaDbtCode") return;
      const error = validateField(field, formData[field]);
      if (error) {
        newErrors[field] = error;
      }
    });
    if (errors.email === "This email is already registered.") {
      newErrors.email = "This email is already registered.";
    }


    if (
      !formData.authorizationLetterFiles ||
      formData.authorizationLetterFiles.length === 0
    ) {
      newErrors.authorizationLetterFiles = "Authorization Letter is required";
    }

    if (!formData.aisheCertificateFiles || formData.aisheCertificateFiles.length === 0) {
      newErrors.aisheCertificateFiles = "AISHE Certificate is required";
    }

    if (!formData.courseAffiliationLetterFiles || formData.courseAffiliationLetterFiles.length === 0) {
      newErrors.courseAffiliationLetterFiles = "College Course Affiliation Letter is required";
    }

    if (!formData.governmentPermissionFiles || formData.governmentPermissionFiles.length === 0) {
      newErrors.governmentPermissionFiles = "Government Permission (GR) is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };




  const getSelectValue = (options, value) =>
    options.find((opt) => opt.value === value) || null;

  const handleReactSelect = (name, selectedOption) => {
    const selectedValue = selectedOption ? selectedOption.value : "";

    setFormData((prev) => {
      if (name === "instituteUnder") {
        return {
          ...prev,
          instituteUnder: selectedOption ? selectedOption.label : "",
          instituteRegionID: selectedOption ? selectedOption.value : "",
        };
      }

      const baseUpdate = {
        ...prev,
        [name]: selectedValue,
        [`${name}Id`]: selectedOption ? selectedOption.id : null,
      };

      // Reset child dropdowns
      if (name === "state") {
        baseUpdate.district = "";
        baseUpdate.districtId = null;
        baseUpdate.taluka = "";
        baseUpdate.talukaId = null;
        baseUpdate.village = "";
        baseUpdate.villageId = null;
      }

      if (name === "district") {
        baseUpdate.taluka = "";
        baseUpdate.talukaId = null;
        baseUpdate.village = "";
        baseUpdate.villageId = null;
      }

      if (name === "taluka") {
        baseUpdate.village = "";
        baseUpdate.villageId = null;
      }

      return baseUpdate;
    });

    setErrors((prev) => {
      const nextErrors = {
        ...prev,
        [name]: validateField(
          name,
          name === "instituteUnder" && selectedOption ? selectedOption.label : selectedValue,
        ),
      };

      // Clear child errors when parent selection changes
      if (name === "state") {
        nextErrors.district = "";
        nextErrors.taluka = "";
        nextErrors.village = "";
      }

      if (name === "district") {
        nextErrors.taluka = "";
        nextErrors.village = "";
      }

      if (name === "taluka") {
        nextErrors.village = "";
      }

      return nextErrors;
    });
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;

    const error = validateField(name, value);

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  //console.log("Form Data:", formData, emailVerification);

  return (
    <>
      {emailVerification.show && (
        <EmailOTP
          data={emailVerification}
          setEmailVerification={setEmailVerification}
        />
      )}

      {aadhaarVerification.show && (
        <AadhaarOTP
          data={aadhaarVerification}
          setAadhaarVerification={setAadhaarVerification}
          setFormData={setFormData}
        />
      )}

      {mobileNumberVerification.show && (
        <MobileOTP
          data={mobileNumberVerification}
          setMobileNumberVerification={setMobileNumberVerification}
        />
      )}

      <div className="card p-4">
        <h5 className="fw-bold mb-5">Institute Registration Details</h5>

        <div className="row">
          <div className="col-md-4 mb-3">
            <label>
              Parent Department <span className="text-danger">*</span>
            </label>

            <Select
              isSearchable
              isClearable
              className={errors.parentDepartment ? "is-invalid" : ""}
              name="parentDepartment"
              value={
                departmentsList
                  .map((dept) => ({
                    label: dept.name,
                    value: dept.id,
                    name: dept.name,
                    code: dept.code,
                    departmentId: dept.departmentId,
                  }))
                  .find((opt) => opt.value === formData.parentDepartmentId) ||
                null
              }
              onChange={(selectedOption) => {
                setFormData((prev) => ({
                  ...prev,
                  parentDepartmentId: selectedOption
                    ? selectedOption.value
                    : null,
                  parentDepartment: selectedOption ? selectedOption.name : "",
                  departmentCode: selectedOption ? selectedOption.code : "",
                  departmentId: selectedOption ? selectedOption.departmentId : null,
                }));

                if (errors.parentDepartment) {
                  setErrors((prev) => ({ ...prev, parentDepartment: "" }));
                }
              }}
              options={departmentsList.map((dept) => ({
                label: dept.name,
                value: dept.id,
                name: dept.name,
                code: dept.code,
                departmentId: dept.departmentId,
              }))}
              placeholder="Select Department"
            />

            {errors.parentDepartment && (
              <div className="invalid-feedback">{errors.parentDepartment}</div>
            )}
          </div>

          <div className="col-md-4 mb-3">
            <label>
              Department Assigned Code <span className="text-danger">*</span>
            </label>

            <input
              name="deptCode"
              className={getInputClass("deptCode")}
              maxLength={20}
              value={formData.deptCode || ""}
              inputMode="text"
              onChange={(e) => {
                const normalizedValue = sanitizeFieldValue("deptCode", e.target.value).toUpperCase();
                setFormData((prev) => ({
                  ...prev,
                  deptCode: normalizedValue,
                }));

                const error = validateField("deptCode", normalizedValue);
                setErrors((prev) => ({
                  ...prev,
                  deptCode: error,
                }));
              }}
              onBlur={(e) => {
                const error = validateField("deptCode", e.target.value);
                setErrors((prev) => ({
                  ...prev,
                  deptCode: error,
                }));
              }}
            />
            {errors.deptCode && (
              <div className="invalid-feedback">{errors.deptCode}</div>
            )}
          </div>

          {/* Institute / AISHE Code */}
          <div className="col-md-4 mb-3">
            <label>
              Institute / AISHE Code (All India Survey on Higher Education){" "}
              <span className="text-danger">*</span>
            </label>

            <input
              name="aisheCode"
              className={getInputClass("aisheCode")}
              value={formData.aisheCode || ""}
              maxLength={7}
              onChange={async (e) => {
                const aisheCode = sanitizeFieldValue("aisheCode", e.target.value).toUpperCase();

                setFormData((prev) => ({
                  ...prev,
                  aisheCode,
                }));

                const error = validateField("aisheCode", aisheCode);

                if (error) {
                  setErrors((prev) => ({
                    ...prev,
                    aisheCode: error,
                  }));
                  return;
                }

                try {
                  const exists = await checkAisheCode(aisheCode.trim());

                  setErrors((prev) => ({
                    ...prev,
                    aisheCode: exists ? "AISHE Code already exists." : "",
                  }));
                } catch (err) {
                  console.error(err);
                }
              }}
            />

            {errors.aisheCode && (
              <div className="invalid-feedback">{errors.aisheCode}</div>
            )}
          </div>

          <div className="col-md-4 mb-3">
            <label>
              Institute{" "}
              <span className="text-danger">*</span>
            </label>

            <input
              name="instituteName"
              className={getInputClass("instituteName")}
              value={formData.instituteName || ""}
              onChange={handleChange}
              onBlur={(e) => {
                const error = validateField("instituteName", e.target.value);
                setErrors((prev) => ({
                  ...prev,
                  instituteName: error,
                }));
              }}
            />

            {errors.instituteName && (
              <div className="invalid-feedback">{errors.instituteName}</div>
            )}
          </div>


          <div className="col-md-4 mb-3">
            <label>
              State <span className="text-danger">*</span>
            </label>

            <Select
              isSearchable
              // isClearable
              isClearable={false}

              name="state"
              options={statesList.map((s) => ({
                value: s.name,
                id: s.id,
                label: s.name,
              }))}
              value={getSelectValue(
                statesList.map((s) => ({ value: s.name, label: s.name })),
                formData.state,
              )}
              onChange={(opt) => handleReactSelect("state", opt)}
              placeholder="Select State"
              className={errors.state ? "is-invalid" : ""}
            />

            {errors.state && (
              <div className="invalid-feedback d-block">{errors.state}</div>
            )}
          </div>

          {/* District */}
          <div className="col-md-4 mb-3">
            <label>
              District <span className="text-danger">*</span>
            </label>

            <Select
              isSearchable
              isClearable
              isDisabled={!districtsList.length}
              name="district"
              options={districtsList.map((d) => ({
                value: d.name,
                id: d.id,
                label: d.name,
              }))}
              value={getSelectValue(
                districtsList.map((d) => ({ value: d.name, label: d.name })),
                formData.district,
              )}
              onChange={(opt) => handleReactSelect("district", opt)}
              placeholder="Select District"
              className={errors.district ? "is-invalid" : ""}
            />

            {errors.district && (
              <div className="invalid-feedback d-block">{errors.district}</div>
            )}
          </div>

          {/* Taluka */}
          <div className="col-md-4 mb-3">
            <label>
              Taluka <span className="text-danger">*</span>
            </label>

            <Select
              isSearchable
              isClearable
              isDisabled={!talukasList.length}
              name="taluka"
              options={talukasList.map((t) => ({
                value: t.name,
                id: t.id,
                label: t.name,
              }))}
              value={getSelectValue(
                talukasList.map((t) => ({ value: t.name, label: t.name })),
                formData.taluka,
              )}
              onChange={(opt) => handleReactSelect("taluka", opt)}
              placeholder="Select Taluka"
              className={errors.taluka ? "is-invalid" : ""}
            />

            {errors.taluka && (
              <div className="invalid-feedback d-block">{errors.taluka}</div>
            )}
          </div>

          <div className="col-md-4 mb-3">
            <label>
              Village
              {/* <span className="text-danger">*</span> */}
            </label>

            <Select
              isSearchable
              isClearable
              isDisabled={!villagesList.length}
              name="village"
              options={villagesList.map((v) => ({
                value: v.name,
                id: v.id,
                label: v.name,
              }))}
              value={getSelectValue(
                villagesList.map((v) => ({ value: v.name, label: v.name })),
                formData.village,
              )}
              onChange={(opt) => handleReactSelect("village", opt)}
              placeholder="Select Village"
              className={errors.village ? "is-invalid" : ""}
            />

            {errors.village && (
              <div className="invalid-feedback d-block">{errors.village}</div>
            )}
          </div>

          {/* Address */}
          <div className="col-md-12 mb-3">
            <label>
              Address <span className="text-danger">*</span>
            </label>
            <textarea
              name="address"
              className={getInputClass("address")}
              value={formData.address || ""}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.address && (
              <div className="invalid-feedback">{errors.address}</div>
            )}
          </div>
          {/* Pincode */}
          <div className="col-md-4 mb-3">
            <label>
              Pincode <span className="text-danger">*</span>
            </label>
            <input
              name="pincode"
              className={getInputClass("pincode")}
              value={formData.pincode || ""}
              onChange={handleChange}
              maxLength={6}
              onBlur={(e) => {
                const error = validateField("pincode", e.target.value);
                setErrors((prev) => ({ ...prev, pincode: error }));
              }}
            />

            {errors.pincode && (
              <div className="invalid-feedback">{errors.pincode}</div>
            )}
          </div>

          {/* Website */}
          <div className="col-md-4 mb-3">
            <label>
              Website <span className="text-danger">*</span>
            </label>
            <input
              name="website"
              className={getInputClass("website")}
              value={formData.website || ""}
              onChange={handleChange}
              onBlur={(e) =>
                setErrors((prev) => ({
                  ...prev,
                  website: validateField("website", e.target.value),
                }))
              }
            />
            {errors.website && (
              <div className="invalid-feedback">{errors.website}</div>
            )}
          </div>
          <div className="col-md-4 mb-3">
            <label>
              STD code <span className="text-danger">*</span>
            </label>
            <input
              name="stdCode"
              className={getInputClass("stdCode")}
              value={formData.stdCode || ""}
              onChange={handleChange}
              maxLength={5}
              onBlur={(e) =>
                setErrors((prev) => ({
                  ...prev,
                  stdCode: validateField("stdCode", e.target.value),
                }))
              }
            />
            {errors.stdCode && (
              <div className="invalid-feedback">{errors.stdCode}</div>
            )}
          </div>
          {/* Phone */}
          <div className="col-md-4 mb-3">
            <label>
              Tel.No <span className="text-danger">*</span>
            </label>
            <input
              name="phone"
              className={getInputClass("phone")}
              value={formData.phone || ""}
              onChange={handleChange}
              maxLength={8}
              minLength={6}
              onBlur={(e) =>
                setErrors((prev) => ({
                  ...prev,
                  phone: validateField("phone", e.target.value),
                }))
              }
            />

            {errors.phone && (
              <div className="invalid-feedback">{errors.phone}</div>
            )}
          </div>



          <div className="col-md-4 mb-3">
            <label>
              Aadhaar Number of Authorised Person <span className="text-danger">*</span>
            </label>

            <div className="d-flex gap-2">
              <input
                inputMode="numeric"
                pattern="\\d*"
                name="aadhaarNumber"
                maxLength={12}
                className={`form-control ${getInputClass("aadhaarNumber")}`}

                value={
                  showMaskedAadhaar && formData.aadhaarNumber?.length === 12
                    ? maskAadhaarNumber(formData.aadhaarNumber)
                    : formData.aadhaarNumber || ""
                }
                onChange={(e) => {
                  let value = e.target.value.replace(/\D/g, "");

                  if (value.length === 1 && !/[2-9]/.test(value)) return;

                  if (value.length > 12) return;

                  setShowMaskedAadhaar(false);

                  setFormData((prev) => ({
                    ...prev,
                    aadhaarNumber: value,
                  }));

                  setErrors((prev) => ({
                    ...prev,
                    aadhaarNumber: validateField("aadhaarNumber", value),
                  }));
                }}
                onBlur={() => {
                  const value = formData.aadhaarNumber;

                  const error = validateField("aadhaarNumber", value);

                  setErrors((prev) => ({
                    ...prev,
                    aadhaarNumber: error,
                  }));

                  if (!error && value.length === 12) {
                    setShowMaskedAadhaar(true);
                  }
                }}
                readOnly={aadhaarVerification.verified}

                onFocus={() => {
                  setShowMaskedAadhaar(false);
                }}
              />

              <button
                type="button"
                className="btn btn-sm btn-primary"
                disabled={
                  !formData.aadhaarNumber ||
                  !validateAadhaarVerhoeff(formData.aadhaarNumber) ||
                  // !/^\d{12}$/.test(formData.aadhaarNumber) ||
                  errors.aadhaarNumber ||
                  aadhaarVerification.verified
                }
                onClick={() => {
                  setShowConsentModal(true);
                }}
              >
                {aadhaarVerification.verified ? "Verified" : "Verify"}
              </button>
            </div>

            {errors.aadhaarNumber && (
              <div className="invalid-feedback d-block">
                {errors.aadhaarNumber}
              </div>
            )}



            {showConsentModal && (
              <>
                <div className="modal-backdrop fade show"></div>

                <div className="modal fade show d-block" tabIndex="-1">
                  <div
                    className="modal-dialog modal-dialog-centered"
                    style={{ maxWidth: "420px", width: "100%" }}
                  >
                    <div className="modal-content border-0 shadow rounded-3 overflow-hidden">

                      <div
                        className="px-3 py-3 d-flex justify-content-between align-items-center"
                        style={{ backgroundColor: "#0b3b82", color: "#fff" }}
                      >
                        <h6 className="mb-0 fw-bold">
                          <i className="bi bi-shield-check me-2"></i>
                          Aadhaar Consent
                        </h6>

                        <button
                          type="button"
                          className="btn-close btn-close-white"
                          onClick={() => {
                            setShowConsentModal(false);
                            setConsentChecked(false);
                          }}
                        />
                      </div>

                      <div className="p-3" style={{ background: "#f4f6f9" }}>

                        <div className="mb-3 text-center">
                          <div className="d-inline-block bg-white px-3 py-2 rounded shadow-sm border">
                            <div
                              className="text-uppercase text-muted"
                              style={{ fontSize: "11px" }}
                            >
                              Aadhaar Number
                            </div>
                            <div className="fw-bold" style={{ fontSize: "16px" }}>
                              {maskAadhaar(formData.aadhaarNumber)}
                            </div>
                          </div>
                        </div>

                        <p className="small text-muted mb-3 text-center">
                          By proceeding, you agree to share your Aadhaar details for identity
                          verification. An OTP will be sent to your registered mobile number.
                        </p>

                        <div className="form-check mb-2">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="consentCheck"
                            checked={consentChecked}
                            onChange={(e) => setConsentChecked(e.target.checked)}
                          />
                          <label className="form-check-label small" htmlFor="consentCheck">
                            I agree and give my consent for Aadhaar verification
                          </label>
                        </div>
                      </div>

                      <div className="px-3 py-2 d-flex justify-content-between align-items-center">

                        <button
                          className="btn btn-outline-secondary mb-2"
                          onClick={() => {
                            setShowConsentModal(false);
                            setConsentChecked(false);
                          }}
                        >
                          Cancel
                        </button>

                        {consentChecked && (
                          <button
                            className="btn mb-2"
                            style={{ backgroundColor: "#0b3b82", color: "#fff" }}
                            onClick={() => {
                              setShowConsentModal(false);
                              setConsentChecked(false);

                              setAadhaarVerification({
                                show: true,
                                verified: false,
                                aadhaarnumber: formData.aadhaarNumber,
                                verifiedAadhaar: "",
                              });

                              // sendOtp(formData.aadhaarNumber);
                            }}
                          >
                            Proceed & Verify
                          </button>
                        )}
                      </div>

                    </div>
                  </div>
                </div>
              </>
            )}


          </div>

          <div className="col-md-4 mb-3">
            <label>
              Institute Email ID <span className="text-danger">*</span>
            </label>

            <div className="d-flex gap-2">
              <input
                name="email"
                className={getInputClass("email")}
                value={formData.email || ""}
                readOnly={emailVerification.verified}
                onChange={async (e) => {
                  const email = e.target.value;

                  handleChange(e);

                  // 🔥 Immediately disable button
                  setCheckingEmail(true);
                  setExists(false);

                  const error = validateField("email", email);

                  if (error) {
                    setErrors((prev) => ({
                      ...prev,
                      email: error,
                    }));
                    setCheckingEmail(false); // stop checking
                    return;
                  }

                  try {
                    const exists = await checkEmailExists(email.trim());

                    setExists(exists);

                    setErrors((prev) => ({
                      ...prev,
                      email: exists
                        ? "This email is already registered."
                        : "",
                    }));
                  } catch (err) {
                    console.error("Email check failed:", err);
                  } finally {
                    setCheckingEmail(false); // ✅ done
                  }
                }}
              />

              <button
                type="button"
                className="btn btn-sm btn-primary"
                disabled={
                  !formData.email ||
                  errors.email ||
                  exists ||
                  checkingEmail ||   // 🔥 key fix
                  emailVerification.verified
                }
                onClick={() =>
                  setEmailVerification({
                    show: true,
                    verified: false,
                    email: formData.email,
                    verifiedEmail: "",
                  })
                }
              >
                {checkingEmail
                  ? "Checking..."
                  : emailVerification.verified
                    ? "Verified"
                    : "Verify"}
              </button>
            </div>

            {errors.email && (
              <div className="invalid-feedback d-block">{errors.email}</div>
            )}
          </div>

          <div className="col-md-4 mb-3">
            <label>
              Name <span className="text-danger">*</span>
            </label>
            <input
              name="creatorUserName"
              className={getInputClass("creatorUserName")}
              value={formData.creatorUserName || ""}
              onChange={handleChange}
              onBlur={(e) =>
                setErrors((prev) => ({
                  ...prev,
                  creatorUserName: validateField(
                    "creatorUserName",
                    e.target.value,
                  ),
                }))
              }
              readOnly={aadhaarVerification.verifyName}
            />

            {errors.creatorUserName && (
              <div className="invalid-feedback">{errors.creatorUserName}</div>
            )}
          </div>

          <div className="col-md-4 mb-3">
            <label>
              Aadhaar Linked Mobile Number <span className="text-danger">*</span>
            </label>

            <div className="d-flex gap-2">
              <input
                inputMode="numeric"
                pattern="\\d*"
                name="mobileNumber"
                className={getInputClass("mobileNumber")}
                value={formData.mobileNumber || ""}
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/\D/g, "");
                  setFormData((prev) => ({
                    ...prev,
                    mobileNumber: numericValue,
                  }));
                  if (errors.mobileNumber) {
                    setErrors((prev) => ({ ...prev, mobileNumber: "" }));
                  }
                }}
                readOnly={mobileNumberVerification.verified}
                maxLength={10}
                onBlur={(e) =>
                  setErrors((prev) => ({
                    ...prev,
                    mobileNumber: validateField("mobileNumber", e.target.value),
                  }))
                }
              />

              <button
                type="button"
                className="btn btn-sm btn-primary"
                disabled={
                  !formData.mobileNumber ||
                  errors.mobileNumber ||
                  mobileNumberVerification.verified
                }
                onClick={() =>
                  setMobileNumberVerification({
                    show: true,
                    verified: false,
                    mobileNumber: formData.mobileNumber,
                    verifiedMobileNumber: "",
                  })
                }
              >
                {mobileNumberVerification.verified ? "Verified" : "Verify"}
              </button>
            </div>

            {errors.mobileNumber && (
              <div className="invalid-feedback d-block">
                {errors.mobileNumber}
              </div>
            )}
          </div>

          {/* Institute Type */}
          <div className="col-md-4 mb-3">
            <label>
              Institute Type <span className="text-danger">*</span>
            </label>

            <Select
              isSearchable
              isClearable
              name="instituteType"
              options={instituteTypesList.map((t) => ({
                value: getPicklistLabel(t),
                label: getPicklistLabel(t),
              }))}
              value={getSelectValue(
                instituteTypesList.map((t) => ({
                  value: getPicklistLabel(t),
                  label: getPicklistLabel(t),
                })),
                formData.instituteType,
              )}
              onChange={(opt) => handleReactSelect("instituteType", opt)}
              placeholder="Select Type"
              className={errors.instituteType ? "is-invalid" : ""}
            />

            {errors.instituteType && (
              <div className="invalid-feedback d-block">
                {errors.instituteType}
              </div>
            )}
          </div>

          {/* Registration Number */}
          <div className="col-md-4 mb-3">
            <label>
              Institute Registration No. <span className="text-danger">*</span>
            </label>
            <input
              name="regNumber"
              className={getInputClass("regNumber")}
              value={formData.regNumber || ""}
              maxLength={15}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            {errors.regNumber && (
              <div className="invalid-feedback">{errors.regNumber}</div>
            )}
          </div>
          {/* Establishment Year */}
          <div className="col-md-4 mb-3">
            <label>
              Establishment Year <span className="text-danger">*</span>
            </label>
            {/* <input
                name="establishYear"
                className={getInputClass("establishYear")}
                value={formData.establishYear || ""}
                onChange={handleChange}
                onBlur={handleBlur}
              /> */}
            <input
              type="text"
              name="establishYear"
              className={getInputClass("establishYear")}
              value={formData.establishYear || ""}
              maxLength={4} // only 4 digits (year)
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); // allow only numbers

                if (value.length <= 4) {
                  setFormData((prev) => ({
                    ...prev,
                    establishYear: value,
                  }));
                }
              }}
              onBlur={(e) => {
                const year = e.target.value;
                const currentYear = new Date().getFullYear();

                let error = "";

                if (!year) {
                  error = "Establishment year is required";
                } else if (year.length !== 4) {
                  error = "Enter a valid 4-digit year";
                } else if (parseInt(year) > currentYear) {
                  error = "Future year is not allowed";
                }

                setErrors((prev) => ({
                  ...prev,
                  establishYear: error,
                }));
              }}
            />
            {errors.establishYear && (
              <div className="invalid-feedback">{errors.establishYear}</div>
            )}
          </div>

          <div className="col-md-4 mb-3">
            <label>
              University Name <span className="text-danger">*</span>
            </label>

            <Select
              isSearchable
              isClearable
              name="university"
              options={universitiesList.map((u) => ({
                value: u.name,
                label: u.name,
              }))}
              value={getSelectValue(
                universitiesList.map((u) => ({ value: u.name, label: u.name })),
                formData.university,
              )}
              onChange={(opt) => handleReactSelect("university", opt)}
              placeholder="Select University"
              className={errors.university ? "is-invalid" : ""}
            />

            {errors.university && (
              <div className="invalid-feedback d-block">
                {errors.university}
              </div>
            )}
          </div>

          <div className="col-md-4 mb-3">
            <label>
              Is Institute Under <span className="text-danger">*</span>
            </label>
            <Select
              isSearchable
              isClearable
              name="instituteUnder"
              options={regionsList.map((t) => ({
                value: t.instituteRegionID,
                label: t.name,
              }))}

              value={getSelectValue(
                regionsList.map((t) => ({ value: t.instituteRegionID, label: t.name })),
                formData.instituteRegionID,
              )}
              onChange={(opt) => handleReactSelect("instituteUnder", opt)}
              placeholder="Select Type"
              className={errors.instituteUnder ? "is-invalid" : ""}
              classNamePrefix="react-select"
            />
            {errors.instituteUnder && (
              <div className="invalid-feedback">{errors.instituteUnder}</div>
            )}
          </div>
          {/* NAAC Accredited */}
          <div className="col-md-4 mb-3">
            <label className="d-block mb-2">
              National Assessment and Accreditation Council (NAAC)?{" "}
              <span className="text-danger">*</span>
            </label>

            <div className="form-check form-check-inline">
              <input
                type="radio"
                className="form-check-input"
                id="naacAccreditedYes"
                name="naacAccredited"
                checked={formData.naacAccredited === true}
                onChange={() => handleRadioChange("naacAccredited", true)}
              />
              <label className="form-check-label" htmlFor="naacAccreditedYes">
                Yes
              </label>
            </div>

            <div className="form-check form-check-inline">
              <input
                type="radio"
                className="form-check-input"
                id="naacAccreditedNo"
                name="naacAccredited"
                checked={formData.naacAccredited === false}
                onChange={() => handleRadioChange("naacAccredited", false)}
              />
              <label className="form-check-label" htmlFor="naacAccreditedNo">
                No
              </label>
            </div>

            {errors.naacAccredited && (
              <div className="invalid-feedback d-block">
                {errors.naacAccredited}
              </div>
            )}
          </div>

          <div className="col-md-4 mb-3">
            <label className="d-block">
              Is this institute under your administration/Department ?
            </label>

            <div className="form-check form-check-inline">
              <input
                type="radio"
                className="form-check-input"
                name="underAdministration"
                checked={formData.underAdministration === true}
                onChange={() => handleRadioChange("underAdministration", true)}
              />
              <label className="form-check-label">Yes</label>
            </div>

            <div className="form-check form-check-inline">
              <input
                type="radio"
                className="form-check-input"
                name="underAdministration"
                checked={formData.underAdministration === false}
                onChange={() => handleRadioChange("underAdministration", false)}
              />
              <label className="form-check-label">No</label>
            </div>
          </div>

          {/* ── Document Uploads ─────────────────────────────────── */}
          <div className="col-12 mb-4">
            <h6
              className="fw-semibold text-muted mb-3"
              style={{ fontSize: 13, textTransform: "uppercase", letterSpacing: "0.05em" }}
            >
              Document Uploads
            </h6>

            <div className="row">

              {/* AICTE Approval */}
              <div className="col-md-4 mb-3">
                <label>AICTE Approval</label>

                <input
                  type="file"
                  name="aicteApprovalFiles"
                  multiple
                  accept=".pdf,application/pdf"
                  className={`form-control ${errors.aicteApprovalFiles ? "is-invalid" : ""}`}
                  onChange={handleFileUpload}
                />
                <div style={{ fontSize: 12, color: "#6c757d", marginTop: 4 }}>
                  Accepted format: PDF (Max 5MB)
                </div>

                {errors.aicteApprovalFiles && (
                  <div className="invalid-feedback d-block">
                    {errors.aicteApprovalFiles}
                  </div>
                )}

                {formData.aicteApprovalFiles?.map((file, i) => (
                  <div key={i} className="d-flex justify-content-between mt-1">
                    <span style={{ fontSize: 12 }}>📄 {file.name}</span>
                    <button type="button" className="btn btn-sm text-danger"
                      onClick={() => handleRemoveFile("aicteApprovalFiles", i)}>✖</button>
                  </div>
                ))}
              </div>

              {/* Authorization Letter */}
              <div className="col-md-4 mb-3">
                <label>
                  Authorization Letter Of Department <span className="text-danger">*</span>
                </label>

                <input
                  type="file"
                  name="authorizationLetterFiles"
                  multiple
                  accept=".pdf,application/pdf"
                  className={`form-control ${errors.authorizationLetterFiles ? "is-invalid" : ""}`}
                  onChange={handleFileUpload}
                />
                <div style={{ fontSize: 12, color: "#6c757d", marginTop: 4 }}>
                  Accepted format: PDF (Max 5MB)
                </div>

                {errors.authorizationLetterFiles && (
                  <div className="invalid-feedback d-block">
                    {errors.authorizationLetterFiles}
                  </div>
                )}

                {formData.authorizationLetterFiles?.map((file, i) => (
                  <div key={i} className="d-flex justify-content-between mt-1">
                    <span style={{ fontSize: 12 }}>📄 {file.name}</span>
                    <button type="button" className="btn btn-sm text-danger"
                      onClick={() => handleRemoveFile("authorizationLetterFiles", i)}>✖</button>
                  </div>
                ))}
              </div>

              {/* AISHE Certificate */}
              <div className="col-md-4 mb-3">
                <label>
                  AISHE Certificate <span className="text-danger">*</span>
                </label>

                <input
                  type="file"
                  name="aisheCertificateFiles"
                  multiple
                  accept=".pdf,application/pdf"
                  className={`form-control ${errors.aisheCertificateFiles ? "is-invalid" : ""}`}
                  onChange={handleFileUpload}
                />
                <div style={{ fontSize: 12, color: "#6c757d", marginTop: 4 }}>
                  Accepted format: PDF (Max 5MB)
                </div>

                {errors.aisheCertificateFiles && (
                  <div className="invalid-feedback d-block">
                    {errors.aisheCertificateFiles}
                  </div>
                )}

                {formData.aisheCertificateFiles?.map((file, i) => (
                  <div key={i} className="d-flex justify-content-between mt-1">
                    <span style={{ fontSize: 12 }}>📄 {file.name}</span>
                    <button type="button" className="btn btn-sm text-danger"
                      onClick={() => handleRemoveFile("aisheCertificateFiles", i)}>✖</button>
                  </div>
                ))}
              </div>

              {/* Course Affiliation */}
              <div className="col-md-4 mb-3">
                <label>
                  Course Affiliation Letter <span className="text-danger">*</span>
                </label>

                <input
                  type="file"
                  name="courseAffiliationLetterFiles"
                  multiple
                  accept=".pdf,application/pdf"
                  className={`form-control ${errors.courseAffiliationLetterFiles ? "is-invalid" : ""}`}
                  onChange={handleFileUpload}
                />
                <div style={{ fontSize: 12, color: "#6c757d", marginTop: 4 }}>
                  Accepted format: PDF (Max 5MB)
                </div>

                {errors.courseAffiliationLetterFiles && (
                  <div className="invalid-feedback d-block">
                    {errors.courseAffiliationLetterFiles}
                  </div>
                )}

                {formData.courseAffiliationLetterFiles?.map((file, i) => (
                  <div key={i} className="d-flex justify-content-between mt-1">
                    <span style={{ fontSize: 12 }}>📄 {file.name}</span>
                    <button type="button" className="btn btn-sm text-danger"
                      onClick={() => handleRemoveFile("courseAffiliationLetterFiles", i)}>✖</button>
                  </div>
                ))}
              </div>

              {/* Government Permission */}
              <div className="col-md-4 mb-3">
                <label>
                  Government Permission (GR) <span className="text-danger">*</span>
                </label>

                <input
                  type="file"
                  name="governmentPermissionFiles"
                  multiple
                  accept=".pdf,application/pdf"
                  className={`form-control ${errors.governmentPermissionFiles ? "is-invalid" : ""}`}
                  onChange={handleFileUpload}
                />
                <div style={{ fontSize: 12, color: "#6c757d", marginTop: 4 }}>
                  Accepted format: PDF (Max 5MB)
                </div>
                {errors.governmentPermissionFiles && (
                  <div className="invalid-feedback d-block">
                    {errors.governmentPermissionFiles}
                  </div>
                )}

                {formData.governmentPermissionFiles?.map((file, i) => (
                  <div key={i} className="d-flex justify-content-between mt-1">
                    <span style={{ fontSize: 12 }}>📄 {file.name}</span>
                    <button type="button" className="btn btn-sm text-danger"
                      onClick={() => handleRemoveFile("governmentPermissionFiles", i)}>✖</button>
                  </div>
                ))}
              </div>

            </div>
          </div>



          {formData.state &&
            normalizeState(formData.state) !== "maharashtra" && (
              <div className="col-md-4 mb-3">
                <div className="form-check">
                  <input
                    type="checkbox"
                    className={`form-check-input ${errors.outsideMaharashtra ? "is-invalid" : ""
                      }`}
                    name="outsideMaharashtra"
                    checked={formData.outsideMaharashtra || false}
                    onChange={handleChange}
                  />
                  <label className="form-check-label">
                    Institute is located outside Maharashtra{" "}
                    <span className="text-danger">*</span>
                  </label>

                  {errors.outsideMaharashtra && (
                    <div className="invalid-feedback d-block">
                      {errors.outsideMaharashtra}
                    </div>
                  )}
                </div>
              </div>
            )}
        </div>

        <div className="d-flex justify-content-between">
          <button
            className="btn btn-primary"
            disabled={
              !emailVerification.verified || !mobileNumberVerification.verified
            }
            onClick={async () => {
              const isValid = validateForm();

              if (!isValid) return;
              if (errors.email === "This email is already registered.") return;

              nextStep();
            }}
          >
            Next →
          </button>
        </div>
      </div>
    </>
  );
};
const buildUserPayloadFromEmail = (formData) => {
  const randomNumber = Math.floor(10000 + Math.random() * 90000);
  const name = formData.instituteName.toLowerCase();
  const firstWord = name.split(" ")[0];
  const cleanName = name.replace(/\s+/g, "");
  const randomLetters = Array.from(
    { length: 6 },
    () => cleanName[Math.floor(Math.random() * cleanName.length)],
  ).join("");
  const collegeNameFirstWord = firstWord + randomLetters;
  const alternateName =
    `${formData.deptCode}${randomNumber}_${collegeNameFirstWord}`.toLowerCase();
  return alternateName;
};

/* =========================
  STEP 3 – REVIEW
========================= */
const ReviewSubmit = ({ formData, prevStep }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [submittedApplicationNumber, setSubmittedApplicationNumber] =
    useState("");
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    const userId = window.Liferay.ThemeDisplay.getUserId();
    const userData = await getUserRolesById(userId);
    const userName = buildUserPayloadFromEmail(formData);
    const DEPARTMENT_COLLEGE_FLAG_MAP = {
      DHED: "flgDhe",
      DTED: "flgDte",
      DMER: "flgDmer",
      DOAR: "flgDOA",
      PWDW: "flgDisability",
      AGRD: "flgAgr",
      ANHD: "flgMUHS",
      SESD: "flgSe",
      SJSA: "flgSj",
      TRBL: "flgTribal",
      SDEE: "flgSKILL",
    };
    const roleIds =
      userData?.roleBriefs
        ?.filter((role) => role.name !== "User")
        .map((role) => role.id) || [];

    const mahaApplicationId = generateApplicationNumber();

    const [
      uploadedAicteDocs,
      uploadedAuthDocs,
      uploadedAisheDocs,
      uploadedCourseAffiliationDocs,
      uploadedGovtPermissionDocs,
    ] = await Promise.all([
      uploadMultipleFiles(formData.aicteApprovalFiles),
      uploadMultipleFiles(formData.authorizationLetterFiles),
      uploadMultipleFiles(formData.aisheCertificateFiles),
      uploadMultipleFiles(formData.courseAffiliationLetterFiles),
      uploadMultipleFiles(formData.governmentPermissionFiles),
    ]);
    console.log("Department Id ..............", formData.departmentId)

    const mapDocs = (docs) =>
      docs.map((doc) => ({
        documentId: doc.documentId,
        name: doc.sanitizedName || doc.title,
        url: doc.downloadURL,
      }));

    let aadhaarNumberToStore = String(formData.aadhaarNumber || "")
      .replace(/\s+/g, "")
      .trim();
    if (/^\d{12}$/.test(aadhaarNumberToStore)) {
      try {
        const aadhaarRefResponse =
          await getAadhaarRefByAadhaar(aadhaarNumberToStore);
        const aadhaarRef = String(
          aadhaarRefResponse?.aadhaarOrRefNumber || "",
        ).trim();

        if (!aadhaarRef) {
          throw new Error("Aadhaar reference not found");
        }
        aadhaarNumberToStore = aadhaarRef;
      } catch (aadhaarRefError) {
        setError("Unable to generate Aadhaar reference. Please try again.");
        setLoading(false);
        return;
      }
    }
    const departmentFlagKey =  DEPARTMENT_COLLEGE_FLAG_MAP[formData.departmentCode];
    const payload = {
      creatorUserName: formData.creatorUserName,
      mobileNumber: formData.mobileNumber,
      aadhaarNumber: aadhaarNumberToStore,
      address: formData.address,
      aisheCode: formData.aisheCode,
      // college code is missing
      collegeContactNumber: formData.phone,
      collegeEmailAddress: formData.email?.toLowerCase(),
      // college id is missing
      // college registratio0n data missing
      collegeRegistrationNo: formData.regNumber,
      // college type id
      collegeVerificationYear: formData.establishYear,
      collegeType: formData.instituteType,
      // depatment id missing
      // parentDepartmentId:formData.parentDepartmentId,
      departmentId: Number(formData.parentDepartmentId),
      departmentCode: formData.departmentCode,
      departmentAssignedCode: formData.deptCode,
      departmentName: formData.parentDepartment,
      districtId: formData.districtId,
      mahaDbtCode: formData.mahaDbtCode,
      mahaApplicationId: mahaApplicationId,
      name: formData.instituteName,
      namell: formData.instituteName,
      pincode: formData.pincode,
      r_districtCollege_c_districtId: formData.districtId,
      r_talukaCollege_c_talukaId: formData.talukaId,
      talukaId: formData.talukaId,
      stateId: formData.stateId,
      villageId: formData.villageId,
      website: formData.website,
      underAdministration: formData.underAdministration,
      stdCode: formData.stdCode,
      universityName: formData.university,
      instituteUnder: formData.instituteUnder,
      instituteRegionID : formData.instituteRegionID,
      naacAccredited: formData.naacAccredited,
      outsideMaharashtra: formData.outsideMaharashtra,
      [departmentFlagKey]: 1,
      aicteApproval: mapDocs(uploadedAicteDocs),
      authorizationLetter: mapDocs(uploadedAuthDocs),
      aisheCertificate: mapDocs(uploadedAisheDocs),
      courseAffiliationLetter: mapDocs(uploadedCourseAffiliationDocs),
      governmentPermission: mapDocs(uploadedGovtPermissionDocs),
    };

    try {
      const data = await creatingEntry(payload);
      const finalApplicationNumber =
        data?.mahaApplicationId || mahaApplicationId;
      setSubmittedApplicationNumber(finalApplicationNumber);
      setShowConfirmation(true);
      console.log("API Response:", data);
    } catch (err) {
      setError(err.message || "Something went wrong while submitting.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="card p-4 shadow-sm">
      {/* Header */}
      <h5 className="fw-bold mb-2 d-flex align-items-center">
        Review Application Details
      </h5>

      <p className="text-muted mb-3">
        Please review all the information before submitting. You can go back to
        edit any details.
      </p>

      {/* Review Table */}
      <table className="table table-bordered align-middle">
        <tbody>
          <tr>
            <td className="fw-semibold">Parent Department</td>
            <td>{formData.parentDepartment}</td>
          </tr>
          <tr>
            <td className="fw-semibold">Department Assigned Code</td>
            <td>{formData.deptCode}</td>
          </tr>
          <tr>
            <td className="fw-semibold">
              Institute / AISHE Code (All India Survey on Higher Education)
            </td>
            <td>{formData.aisheCode}</td>
          </tr>


          <tr>
            <td className="fw-semibold">Institute</td>
            <td>{formData.instituteName}</td>
          </tr>
          <tr>
            <td className="fw-semibold">Address</td>
            <td>{formData.address}</td>
          </tr>



          <tr><td className="fw-semibold">State</td><td>{formData.state}</td></tr>
          <tr><td className="fw-semibold">District</td><td>{formData.district}</td></tr>
          <tr><td className="fw-semibold">Taluka</td><td>{formData.taluka}</td></tr>
          <tr><td className="fw-semibold">Village</td><td>{formData.village}</td></tr>
          <tr><td className="fw-semibold">Pincode</td><td>{formData.pincode}</td></tr>
          <tr>
            <td className="fw-semibold">Website</td>
            <td>{formData.website}</td>
          </tr>
          <tr><td className="fw-semibold">STD Code</td><td>{formData.stdCode}</td></tr>
          <tr>
            <td className="fw-semibold">Email ID</td>
            <td>{formData.email}</td>
          </tr>
          <tr>
            <td className="fw-semibold">Tel.No</td>
            {/* <td>{formData.phone}</td> */}
            <td>{formData.stdCode}-{formData.phone}</td>
          </tr>
          <tr>
            <td className="fw-semibold">Aadhaar Number</td>
            <td>{formData.aadhaarNumber}</td>
          </tr>
          <tr>
            <td className="fw-semibold">Name</td>
            <td>{formData.creatorUserName}</td>
          </tr>
          <tr>
            <td className="fw-semibold">Mobile Number </td>
            <td>{formData.mobileNumber}</td>
          </tr>
          <tr>
            <td className="fw-semibold">Institute Type</td>
            <td>{formData.instituteType}</td>
          </tr>
          <tr>
            <td className="fw-semibold">Institute Registration No.</td>
            <td>{formData.regNumber}</td>
          </tr>
          <tr>
            <td className="fw-semibold">NAAC Accredited</td>
            <td>{formData.naacAccredited ? "Yes" : "No"}</td>
          </tr>

          <tr>
            <td className="fw-semibold">Outside Maharashtra</td>
            <td>{formData.outsideMaharashtra ? "Yes" : "No"}</td>
          </tr>

          <tr>
            <td className="fw-semibold">Establishment Year</td>
            <td>{formData.establishYear}</td>
          </tr>

          <tr>
            <td className="fw-semibold">University Name</td>
            <td>{formData.university}</td>
          </tr>

          <tr>
            <td className="fw-semibold">Institute Under</td>
            <td>{formData.instituteUnder}</td>
          </tr>
          <tr>
            <td className="fw-semibold">Under Administration / Department</td>
            <td>
              {formData.underAdministration === null
                ? "-"
                : formData.underAdministration
                  ? "Yes"
                  : "No"}
            </td>
          </tr>
          <tr>
            <td className="fw-semibold">AICTE Approval</td>
            <td>
              {formData.aicteApprovalFiles?.map((file, i) => (
                <div key={i}>{file.name}</div>
              ))}
            </td>
          </tr>

          <tr>
            <td className="fw-semibold">Authorization Letter Of Department</td>
            <td>{formData.authorizationLetterFiles?.map((f, i) => <div key={i}>{f.name}</div>)}</td>
          </tr>
          <tr>
            <td className="fw-semibold">AISHE Certificate</td>
            <td>{formData.aisheCertificateFiles?.map((f, i) => <div key={i}>{f.name}</div>)}</td>
          </tr>
          <tr>
            <td className="fw-semibold">College Course Affiliation Letter</td>
            <td>{formData.courseAffiliationLetterFiles?.map((f, i) => <div key={i}>{f.name}</div>)}</td>
          </tr>
          <tr>
            <td className="fw-semibold">Government Permission (GR)</td>
            <td>{formData.governmentPermissionFiles?.map((f, i) => <div key={i}>{f.name}</div>)}</td>
          </tr>
        </tbody>
      </table>

      {/* Important Info */}
      <div className="alert alert-info mt-3">
        <strong>Important:</strong> Once submitted, you cannot edit the
        application. Please ensure all details are correct.
      </div>

      <div className="form-check mt-3">
        <input
          className="form-check-input"
          type="checkbox"
          id="declarationCheck"
          checked={declarationChecked}
          onChange={(e) => setDeclarationChecked(e.target.checked)}
        />
        <label className="form-check-label" htmlFor="declarationCheck">
          I confirm that all details are being uploaded by an Aadhaar verified
          authorized person and the application is liable for rejection if any
          wrong details are found.
        </label>
      </div>

      {/* Buttons */}
      <div className="d-flex justify-content-between mt-4">
        <button className="btn btn-primary" onClick={prevStep}>
          ← Previous
        </button>
        <button
          className="btn btn-primary px-4"
          onClick={handleSubmit}
          disabled={loading || !declarationChecked}
        >
          {loading ? "Submitting..." : "Submit Application"}
        </button>
      </div>
      {!declarationChecked && (
        <small className="text-muted d-block mt-2">
          Please accept the declaration to enable submission.
        </small>
      )}
      {showConfirmation && (
        <Confirmation applicationNumber={submittedApplicationNumber} />
      )}
    </div>
  );
};

const generateApplicationNumber = () => {
  const year = new Date().getFullYear();
  const random = Math.floor(10000 + Math.random() * 90000);
  return `MAH-${year}-${random}`;
};

/* =========================
  STEP 4 – CONFIRMATION
========================= */
const Confirmation = ({ applicationNumber }) => {
  return (
    <>
      <div
        className="modal-backdrop fade show"
        style={{ backgroundColor: "rgba(0,0,0,0.35)" }}
      />
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content border-0 shadow rounded-4">
            <div className="modal-body text-center p-4">
              <h5 className="text-primary fw-bold mb-2">
                Application Submitted Successfully
              </h5>
              <p className="text-muted mb-3">
                Your institute onboarding form has been submitted.
              </p>

              <div className="alert alert-primary py-2 mb-3">
                Application Number <strong>{applicationNumber}</strong>
              </div>

              <button
                className="btn btn-primary px-4"
                onClick={() => (window.location.href = "/home")}
              >
                Go to Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

//  local code

// import React, { useState, useEffect } from "react";
// import {
//   FaBook,
//   FaPenFancy,
//   FaHospital,
//   FaTools,
//   FaCheck,
// } from "react-icons/fa";
// import { FcDepartment } from "react-icons/fc";
// import "../style/InstituteOnBoarding.css";
// import { validationRules } from "../validations/Validation";
// import {
//   getStates,
//   fetchDistrictsByState,
//   fetchTalukasByDistrict,
//   getDepartment,
//   getUniversity,
//   getColleges,
//   getPicklistByERC,
//   creatingEntry,
//   fetchVillagesByTaluka,
//   checkEmailExists,
//   checkAisheCode,
// } from "../api/fetch-masters.js";
// import Select from "react-select";
// import { getUserRolesById } from "../api/userService.js";
// import { uploadAttachmentByFolderName } from "../api/upload.js";
// import { useNavigate } from "react-router";
// import EmailOTP from "../modal/EmailOTP";
// import AadhaarOTP from "../modal/AadhaarOTP";
// import MobileOTP from "../modal/MobileOTP";
// import { verifyEmailOTP } from "../api/verify-otp.js";
// const siteId = window.Liferay?.ThemeDisplay?.getScopeGroupId();

// const uploadMultipleFiles = async (filesArray) => {
//   if (!filesArray || filesArray.length === 0) return [];

//   const uploadedDocs = await Promise.all(
//     filesArray.map((file) =>
//       uploadAttachmentByFolderName(siteId, file, "Institute Documents"),
//     ),
//   );

//   return uploadedDocs;
// };
// /* =========================
//    MAIN COMPONENT
// ========================= */
// const InstituteOnBoarding = () => {
//   const [step, setStep] = useState(1);
//   const [departmentsList, setDepartmentsList] = useState([]);
//   const navigate = useNavigate();

//   const initialFormData = {
//     parentDepartmentId: null,
//     parentDepartment: "",
//     deptCode: "",
//     aisheCode: "",
//     instituteName: "",
//     departmentCode: "",
//     stateId: null,
//     state: "Maharashtra",
//     districtId: null,
//     district: "",
//     talukaId: null,
//     taluka: "",
//     villageId: null,
//     village: "",
//     pincode: "",
//     address: "",

//     website: "",
//     stdCode: "",
//     email: "",
//     phone: "",

//     instituteType: "",
//     regNumber: "",
//     establishYear: "",

//     naacAccredited: null,
//     underAdministration: null,
//     university: "",
//     instituteUnder: "",
//     mahaDbtCode: "",

//     outsideMaharashtra: false,
//     aicteApprovalFiles: [],
//     authorizationLetterFiles: [],
//     aadhaarNumber: "",
//     creatorUserName: "",
//     mobieleNumber: "",
//     emailVerified: false,
//     aadhaarVerified: false,
//     mobileVerified: false,
//   };
//   const nextStep = () => setStep((p) => p + 1);
//   const prevStep = () => setStep((p) => p - 1);

//   useEffect(() => {
//     const fetchDepartments = async () => {
//       try {
//         const department = await getDepartment();
//         const mappedDepartments = department.map((dept) => ({
//           id: dept.id,
//           name: dept.name,
//           code: dept.code,
//           departmentId: dept.departmentId,
//         }));

//         setDepartmentsList(mappedDepartments);
//       } catch (error) {
//         console.error("Failed to fetch departments:", error);
//       }
//     };

//     fetchDepartments();
//   }, []);

//   const [formData, setFormData] = useState(initialFormData);

//   const [emailVerification, setEmailVerification] = useState({
//     show: false,
//     verified: false,
//     email: "",
//     verifiedEmail: "",
//   });

//   const [aadhaarVerification, setAadhaarVerification] = useState({
//     show: false,
//     verified: false,
//     aadhaarnumber: "",
//     verifiedAadhaar: "",
//     verifyName: false,
//   });

//   const [mobileNumberVerification, setMobileNumberVerification] = useState({
//     show: false,
//     verified: false,
//     mobileNumber: "",
//     verifiedMobileNumber: "",
//   });

//   return (
//     <div className="container my-4">
//       <div className="card shadow-lg border-0 mb-4">
//         <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center py-3">
//           <h5 className="mb-0 fw-semibold">
//             <i className="fas fa-university me-2"></i>
//             Institute Registration
//           </h5>

//           <button
//             className="btn btn-sm fw-semibold"
//             style={{
//               color: "#ffffff",
//             }}
//             onClick={() => navigate("/")}
//           >
//             ← Back
//           </button>
//         </div>
//       </div>
//       {step < 3 && <RegistrationProgress step={step} />}

//       {step === 1 && (
//         <InstituteDetails
//           formData={formData}
//           setFormData={setFormData}
//           nextStep={nextStep}
//           prevStep={prevStep}
//           departmentsList={departmentsList}
//           setDepartmentsList={setDepartmentsList}
//           emailVerification={emailVerification}
//           setEmailVerification={setEmailVerification}

//           aadhaarVerification={aadhaarVerification}
//           setAadhaarVerification={setAadhaarVerification}

//           mobileNumberVerification={mobileNumberVerification}
//           setMobileNumberVerification={setMobileNumberVerification}
//         />
//       )}

//       {step === 2 && <ReviewSubmit formData={formData} prevStep={prevStep} />}
//     </div>
//   );
// };

// export default InstituteOnBoarding;

// /* =========================
//    REGISTRATION PROGRESS
// ========================= */
// const RegistrationProgress = ({ step }) => {
//   const steps = ["Institute Details", "Review & Submit"];
//   const currentStep = Math.min(step, 2);

//   return (
//     <div className="card p-4 mb-4">
//       <h5 className="mb-4">Registration Progress</h5>

//       <div className="progress-container">
//         {steps.map((label, index) => {
//           const stepNumber = index + 1;
//           const isCompleted = currentStep > stepNumber;
//           const isActive = currentStep === stepNumber;

//           return (
//             <div className="progress-step" key={stepNumber}>
//               <div
//                 className={`step-circle
//                   ${isCompleted ? "completed" : ""}
//                   ${isActive ? "active" : ""}
//                 `}
//               >
//                 {isCompleted ? <FaCheck size={12} /> : stepNumber}
//               </div>
//               <span className="step-label">{label}</span>
//               {stepNumber !== steps.length && (
//                 <div
//                   className={`step-line ${currentStep > stepNumber ? "line-completed" : ""}`}
//                 />
//               )}
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// /* =========================
//    STEP 1 – INSTITUTE FORM
// ========================= */
// const InstituteDetails = ({
//   formData,
//   setFormData,
//   nextStep,
//   prevStep,
//   departmentsList,
//   setDepartmentsList,

//   emailVerification,
//   setEmailVerification,

//   aadhaarVerification,
//   setAadhaarVerification,

//   mobileNumberVerification,
//   setMobileNumberVerification,
// }) => {
//   const [statesList, setStatesList] = useState([]);
//   const [districtsList, setDistrictsList] = useState([]);
//   const [talukasList, setTalukasList] = useState([]);
//   const [universitiesList, setUniversitiesList] = useState([]);
//   const [instituteTypesList, setInstituteTypesList] = useState([]);
//   const [instituteUnderList, setInstituteUnderList] = useState([]);
//   const [villagesList, setVillagesList] = useState([]);
//   const [errors, setErrors] = useState({});
//   const maxFileSizeBytes = 5 * 1024 * 1024;
//   const isLocalEnvironment = (() => {
//     if (typeof window === "undefined") return false;

//     const hostname = window.location.hostname;
//     const queryParams = new URLSearchParams(window.location.search);

//     return (
//       ["localhost", "127.0.0.1"].includes(hostname) ||
//       queryParams.get("otpBypass") === "1"
//     );
//   })();
//   // const [emailChecking, setEmailChecking] = useState(false);
//   const [exists, setExists] = useState(false);
//   // const [emailVerification, setEmailVerification] = useState({
//   //   show: false,
//   //   verified: false,
//   //   email: "",
//   //   verifiedEmail: "",
//   // });
//   // const [aadhaarVerification, setAadhaarVerification] = useState({
//   //   show: false,
//   //   verified: false,
//   //   aadhaarnumber: "",
//   //   verifiedAadhaar: "",
//   //   verifyName: false,
//   // });

//   // const [mobileNumberVerification, setMobileNumberVerification] = useState({
//   //   show: false,
//   //   verified: false,
//   //   mobileNumber: "",
//   //   verifiedMobileNumber: "",
//   // });

//   const getInputClass = (field) =>
//     `form-control ${errors[field] ? "is-invalid" : ""}`;

//   const getPicklistLabel = (item) => {
//     const name = item?.name;
//     if (typeof name === "string") return name;
//     if (name && typeof name === "object") {
//       return name.en_US || name["en_US"] || Object.values(name)[0] || "";
//     }
//     return item?.key || "";
//   };

//   // Fetch States on mount
//   useEffect(() => {
//     const fetchAllStates = async () => {
//       const states = await getStates();
//       setStatesList(states);
//       const maha = states.find(
//         (s) => s.name.toLowerCase() === "maharashtra"
//       );

//       if (maha) {
//         setFormData((prev) => ({
//           ...prev,
//           state: maha.name,
//           stateId: maha.id,
//         }));
//       }
//     };
//     fetchAllStates();
//   }, []);

//   useEffect(() => {
//     if (!formData.state) {
//       setDistrictsList([]);
//       return;
//     }

//     const loadDistricts = async () => {
//       const selectedState = statesList.find((s) => s.name === formData.state);
//       if (!selectedState) return;

//       const districts = await fetchDistrictsByState(selectedState.id);
//       setDistrictsList(districts);
//     };

//     loadDistricts();
//   }, [formData.state, statesList]);

//   useEffect(() => {
//     if (!formData.taluka) {
//       setVillagesList([]);
//       return;
//     }

//     const loadVillages = async () => {
//       const selectedTaluka = talukasList.find(
//         (t) => t.name === formData.taluka,
//       );
//       if (!selectedTaluka) return;

//       const villages = await fetchVillagesByTaluka(selectedTaluka.id);
//       setVillagesList(villages);
//     };

//     loadVillages();
//   }, [formData.taluka, talukasList]);

//   useEffect(() => {
//     if (!formData.district) {
//       setTalukasList([]);
//       return;
//     }

//     const loadTalukas = async () => {
//       const selectedDistrict = districtsList.find(
//         (d) => d.name === formData.district,
//       );
//       if (!selectedDistrict) return;

//       const talukas = await fetchTalukasByDistrict(selectedDistrict.id);
//       setTalukasList(talukas);
//     };

//     loadTalukas();
//   }, [formData.district, districtsList]);

//   useEffect(() => {
//     const fetchUniversities = async () => {
//       try {
//         const universities = await getUniversity();
//         setUniversitiesList(universities);
//       } catch (err) {
//         console.error("Failed to fetch universities", err);
//       }
//     };

//     fetchUniversities();
//   }, []);

//   useEffect(() => {
//     const fetchPicklists = async () => {
//       try {
//         const [types, instituteUnder] = await Promise.all([
//           getPicklistByERC("INSTITUTE_TYPE_01"),
//           getPicklistByERC("IS_INSTITUTE_UNDER_01"),
//         ]);

//         setInstituteTypesList(types);
//         setInstituteUnderList(instituteUnder);
//       } catch (err) {
//         console.error("Failed to fetch picklists", err);
//       }
//     };

//     fetchPicklists();
//   }, []);

//   const normalizeState = (value = "") =>
//     typeof value === "string" ? value.trim().toLowerCase() : "";

//   useEffect(() => {
//     if (normalizeState(formData.state) === "maharashtra") {
//       setFormData((prev) => ({
//         ...prev,
//         outsideMaharashtra: false,
//       }));

//       setErrors((prev) => ({
//         ...prev,
//         outsideMaharashtra: "",
//       }));
//     }
//   }, [formData.state]);

//   const handleFileUpload = (e) => {
//     const { name, files } = e.target;
//     const newFiles = Array.from(files);

//     const invalidFile = newFiles.find((file) => {
//       const isPdf =
//         file.type === "application/pdf" ||
//         String(file.name || "").toLowerCase().endsWith(".pdf");

//       return !isPdf || file.size > maxFileSizeBytes;
//     });

//     if (invalidFile) {
//       setErrors((prev) => ({
//         ...prev,
//         [name]: "Only PDF files up to 5 MB are allowed.",
//       }));
//       e.target.value = "";
//       return;
//     }

//     setFormData((prev) => ({
//       ...prev,
//       [name]: [...(prev[name] || []), ...newFiles],
//     }));

//     setErrors((prev) => ({
//       ...prev,
//       [name]: "",
//     }));

//     e.target.value = "";
//   };

//   const handleRemoveFile = (fieldName, index) => {
//     setFormData((prev) => ({
//       ...prev,
//       [fieldName]: prev[fieldName].filter((_, i) => i !== index),
//     }));

//     setErrors((prev) => ({
//       ...prev,
//       [fieldName]:
//         fieldName === "authorizationLetterFiles" &&
//         formData.authorizationLetterFiles?.length === 1
//           ? "Authorization Letter is required"
//           : "",
//     }));
//   };

//   //   const handleChange = (e) => {
//   //   const { name, value, type, checked } = e.target;

//   //   const finalValue =
//   //     type === "checkbox" ? checked : value;

//   //   // Update form data
//   //   setFormData((prev) => ({
//   //     ...prev,
//   //     [name]: finalValue,
//   //   }));

//   //   const error = validateField(name, finalValue);

//   //   setErrors((prev) => ({
//   //     ...prev,
//   //     [name]: error,
//   //   }));
//   // };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     const finalValue = type === "checkbox" ? checked : value;

//     setFormData((prev) => ({
//       ...prev,
//       [name]: finalValue,
//     }));

//     // Just clear old error
//     if (errors[name]) {
//       setErrors((prev) => ({
//         ...prev,
//         [name]: "",
//       }));
//     }
//   };

//   const handleRadioChange = (name, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));

//     if (errors[name]) {
//       setErrors((prev) => ({
//         ...prev,
//         [name]: "",
//       }));
//     }
//   };

//   // const validateField = (name, value) => {
//   //   const rule = validationRules[name];
//   //   if (!rule) return "";

//   //   if (typeof value === "string" && value.startsWith(" ")) {
//   //     return "Leading spaces are not allowed";
//   //   }
//   //   const trimmedValue =
//   //     typeof value === "string" ? value.trim() : value;

//   //   // Required check
//   //   if (rule.required && (trimmedValue === "" || trimmedValue === null)) {
//   //     return rule.message;
//   //   }

//   //   // Pattern check
//   //   if (rule.pattern && trimmedValue && !rule.pattern.test(trimmedValue)) {
//   //     return rule.message;
//   //   }

//   //   return "";
//   // };

//   const validateField = (name, value) => {
//     const rule = validationRules[name];
//     console.log("fghjkl==============", rule);
//     if (!rule) return "";

//     const trimmedValue = typeof value === "string" ? value.trim() : value;

//     const isEmptyValue =
//       trimmedValue === "" ||
//       trimmedValue === null ||
//       trimmedValue === undefined;

//     if (rule.required && isEmptyValue) {
//       return rule.message;
//     }

//     if (!rule.required && isEmptyValue) {
//       return "";
//     }

//     if (typeof value === "string" && value.startsWith(" ")) {
//       return "Leading spaces are not allowed";
//     }

//     if (rule.pattern && !rule.pattern.test(trimmedValue)) {
//       return rule.message;
//     }

//     return "";
//   };

//   const validateForm = () => {
//     const newErrors = {};

//     Object.keys(validationRules).forEach((field) => {
//       // if (field === "phone" || field === "deptCode") {
//       if (field === "deptCode") {
//         return;
//       }
//       if (field === "mahaDbtCode") return;
//       const error = validateField(field, formData[field]);
//       if (error) {
//         newErrors[field] = error;
//       }
//     });
//     if (errors.email === "This email is already registered.") {
//       newErrors.email = "This email is already registered.";
//     }

//     // if (!formData.aicteApprovalFiles || formData.aicteApprovalFiles.length === 0) {
//     //   newErrors.aicteApprovalFiles = "AICTE Approval is required";
//     // }

//     if (
//       !formData.authorizationLetterFiles ||
//       formData.authorizationLetterFiles.length === 0
//     ) {
//       newErrors.authorizationLetterFiles = "Authorization Letter is required";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const getSelectValue = (options, value) =>
//     options.find((opt) => opt.value === value) || null;

//   const handleReactSelect = (name, selectedOption) => {
//     const selectedValue = selectedOption ? selectedOption.value : "";

//     setFormData((prev) => {
//       const baseUpdate = {
//         ...prev,
//         [name]: selectedValue,
//         [`${name}Id`]: selectedOption ? selectedOption.id : null,
//       };

//       // Reset child dropdowns
//       if (name === "state") {
//         baseUpdate.district = "";
//         baseUpdate.districtId = null;
//         baseUpdate.taluka = "";
//         baseUpdate.talukaId = null;
//         baseUpdate.village = "";
//         baseUpdate.villageId = null;
//       }

//       if (name === "district") {
//         baseUpdate.taluka = "";
//         baseUpdate.talukaId = null;
//         baseUpdate.village = "";
//         baseUpdate.villageId = null;
//       }

//       if (name === "taluka") {
//         baseUpdate.village = "";
//         baseUpdate.villageId = null;
//       }

//       return baseUpdate;
//     });

//     setErrors((prev) => {
//       const nextErrors = {
//         ...prev,
//         [name]: validateField(name, selectedValue),
//       };

//       // Clear child errors when parent selection changes
//       if (name === "state") {
//         nextErrors.district = "";
//         nextErrors.taluka = "";
//         nextErrors.village = "";
//       }

//       if (name === "district") {
//         nextErrors.taluka = "";
//         nextErrors.village = "";
//       }

//       if (name === "taluka") {
//         nextErrors.village = "";
//       }

//       return nextErrors;
//     });
//   };

//   const handleBlur = (e) => {
//     const { name, value } = e.target;

//     const error = validateField(name, value);

//     setErrors((prev) => ({
//       ...prev,
//       [name]: error,
//     }));
//   };

//   const activateLocalAadhaarVerification = () => {
//     setAadhaarVerification({
//       show: false,
//       verified: true,
//       aadhaarnumber: formData.aadhaarNumber,
//       verifiedAadhaar: formData.aadhaarNumber,
//       verifyName: false,
//     });
//   };

//   const activateLocalEmailVerification = () => {
//     setEmailVerification({
//       show: false,
//       verified: true,
//       email: formData.email,
//       verifiedEmail: formData.email,
//     });
//   };

//   const activateLocalMobileVerification = () => {
//     setMobileNumberVerification({
//       show: false,
//       verified: true,
//       mobileNumber: formData.mobileNumber,
//       verifiedMobileNumber: formData.mobileNumber,
//     });
//   };

//   const canProceedWithoutOtp =
//     isLocalEnvironment ||
//     (emailVerification.verified && mobileNumberVerification.verified);

//   console.log("Form Data:", formData, emailVerification);

//   return (
//     <>
//       {emailVerification.show && (
//         <EmailOTP
//           data={emailVerification}
//           setEmailVerification={setEmailVerification}
//         />
//       )}

//       {aadhaarVerification.show && (
//         <AadhaarOTP
//           data={aadhaarVerification}
//           setAadhaarVerification={setAadhaarVerification}
//           setFormData={setFormData}
//         />
//       )}

//       {mobileNumberVerification.show && (
//         <MobileOTP
//           data={mobileNumberVerification}
//           setMobileNumberVerification={setMobileNumberVerification}
//         />
//       )}

//       <div className="card p-4">
//         <h5 className="fw-bold mb-5">Institute Registration Details</h5>

//         <div className="row">
//           <div className="col-md-4 mb-3">
//             <label>
//               Parent Department <span className="text-danger">*</span>
//             </label>

//             <Select
//               isSearchable
//               isClearable
//               className={errors.parentDepartment ? "is-invalid" : ""}
//               name="parentDepartment"
//               value={
//                 departmentsList
//                   .map((dept) => ({
//                     label: dept.name,
//                     value: dept.id,
//                     name: dept.name,
//                     code: dept.code,
//                     departmentId: dept.departmentId,
//                   }))
//                   .find((opt) => opt.value === formData.parentDepartmentId) ||
//                 null
//               }
//               onChange={(selectedOption) => {
//                 setFormData((prev) => ({
//                   ...prev,
//                   parentDepartmentId: selectedOption
//                     ? selectedOption.value
//                     : null,
//                   parentDepartment: selectedOption ? selectedOption.name : "",
//                   departmentCode: selectedOption ? selectedOption.code : "",
//                   departmentId: selectedOption ? selectedOption.departmentId : null,
//                 }));

//                 if (errors.parentDepartment) {
//                   setErrors((prev) => ({ ...prev, parentDepartment: "" }));
//                 }
//               }}
//               options={departmentsList.map((dept) => ({
//                 label: dept.name,
//                 value: dept.id,
//                 name: dept.name,
//                 code: dept.code,
//                 departmentId:dept.departmentId,
//               }))}
//               placeholder="Select Department"
//             />

//             {errors.parentDepartment && (
//               <div className="invalid-feedback">{errors.parentDepartment}</div>
//             )}
//           </div>

//           <div className="col-md-4 mb-3">
//             <label>
//               Department Assigned Code <span className="text-danger">*</span>
//             </label>

//             <input
//               name="deptCode"
//               className="form-control"
//               value={formData.deptCode || ""}
//               inputMode="numeric"
//               pattern="\\d*"
//               onChange={(e) => {
//                 const numericValue = e.target.value.replace(/\D/g, "");
//                 setFormData((prev) => ({
//                   ...prev,
//                   deptCode: numericValue,
//                 }));
//                 if (errors.deptCode) {
//                   setErrors((prev) => ({ ...prev, deptCode: "" }));
//                 }
//               }}
//               onBlur={(e) => {
//                 const error = validateField("deptCode", e.target.value);
//                 setErrors((prev) => ({
//                   ...prev,
//                   deptCode: error,
//                 }));
//               }}
//             />
//           </div>

//           {/* Institute / AISHE Code */}
//           <div className="col-md-4 mb-3">
//             <label>
//               Institute / AISHE Code (All India Survey on Higher Education){" "}
//               <span className="text-danger">*</span>
//             </label>

//             <input
//               name="aisheCode"
//               className={getInputClass("aisheCode")}
//               value={formData.aisheCode || ""}
//               onChange={async (e) => {
//                 const aisheCode = e.target.value;

//                 handleChange(e);

//                 const error = validateField("aisheCode", aisheCode);

//                 if (error) {
//                   setErrors((prev) => ({
//                     ...prev,
//                     aisheCode: error,
//                   }));
//                   return;
//                 }

//                 try {
//                   const exists = await checkAisheCode(aisheCode.trim());

//                   setErrors((prev) => ({
//                     ...prev,
//                     aisheCode: exists ? "AISHE Code already exists." : "",
//                   }));
//                 } catch (err) {
//                   console.error(err);
//                 }
//               }}
//             />

//             {errors.aisheCode && (
//               <div className="invalid-feedback">{errors.aisheCode}</div>
//             )}
//           </div>

//           <div className="col-md-4 mb-3">
//             <label>
//               Institute Name / School Name{" "}
//               <span className="text-danger">*</span>
//             </label>

//             <input
//               name="instituteName"
//               className={getInputClass("instituteName")}
//               value={formData.instituteName || ""}
//               onChange={handleChange}
//               onBlur={(e) => {
//                 const error = validateField("instituteName", e.target.value);
//                 setErrors((prev) => ({
//                   ...prev,
//                   instituteName: error,
//                 }));
//               }}
//             />

//             {errors.instituteName && (
//               <div className="invalid-feedback">{errors.instituteName}</div>
//             )}
//           </div>

//           {/* <div className="col-md-4 mb-3">
//           <label>
//             Maha DBT Code
//           </label>

//           <input
//             name="mahaDbtCode"
//             className={getInputClass("mahaDbtCode")}
//             value={formData.mahaDbtCode || ""}
//             onChange={handleChange}
//             onBlur={handleBlur}
//           />

//           {errors.mahaDbtCode && (
//             <div className="invalid-feedback">
//               {errors.mahaDbtCode}
//             </div>
//           )}

//         </div> */}

//           <div className="col-md-4 mb-3">
//             <label>
//               State <span className="text-danger">*</span>
//             </label>

//             <Select
//               isSearchable
//               // isClearable
//               isClearable={false}

//               name="state"
//               options={statesList.map((s) => ({
//                 value: s.name,
//                 id: s.id,
//                 label: s.name,
//               }))}
//               value={getSelectValue(
//                 statesList.map((s) => ({ value: s.name, label: s.name })),
//                 formData.state,
//               )}
//               onChange={(opt) => handleReactSelect("state", opt)}
//               placeholder="Select State"
//               className={errors.state ? "is-invalid" : ""}
//             />

//             {errors.state && (
//               <div className="invalid-feedback d-block">{errors.state}</div>
//             )}
//           </div>

//           {/* District */}
//           <div className="col-md-4 mb-3">
//             <label>
//               District <span className="text-danger">*</span>
//             </label>

//             <Select
//               isSearchable
//               isClearable
//               isDisabled={!districtsList.length}
//               name="district"
//               options={districtsList.map((d) => ({
//                 value: d.name,
//                 id: d.id,
//                 label: d.name,
//               }))}
//               value={getSelectValue(
//                 districtsList.map((d) => ({ value: d.name, label: d.name })),
//                 formData.district,
//               )}
//               onChange={(opt) => handleReactSelect("district", opt)}
//               placeholder="Select District"
//               className={errors.district ? "is-invalid" : ""}
//             />

//             {errors.district && (
//               <div className="invalid-feedback d-block">{errors.district}</div>
//             )}
//           </div>

//           {/* Taluka */}
//           <div className="col-md-4 mb-3">
//             <label>
//               Taluka <span className="text-danger">*</span>
//             </label>

//             <Select
//               isSearchable
//               isClearable
//               isDisabled={!talukasList.length}
//               name="taluka"
//               options={talukasList.map((t) => ({
//                 value: t.name,
//                 id: t.id,
//                 label: t.name,
//               }))}
//               value={getSelectValue(
//                 talukasList.map((t) => ({ value: t.name, label: t.name })),
//                 formData.taluka,
//               )}
//               onChange={(opt) => handleReactSelect("taluka", opt)}
//               placeholder="Select Taluka"
//               className={errors.taluka ? "is-invalid" : ""}
//             />

//             {errors.taluka && (
//               <div className="invalid-feedback d-block">{errors.taluka}</div>
//             )}
//           </div>

//           <div className="col-md-4 mb-3">
//             <label>
//               Village
//               {/* <span className="text-danger">*</span> */}
//             </label>

//             <Select
//               isSearchable
//               isClearable
//               isDisabled={!villagesList.length}
//               name="village"
//               options={villagesList.map((v) => ({
//                 value: v.name,
//                 id: v.id,
//                 label: v.name,
//               }))}
//               value={getSelectValue(
//                 villagesList.map((v) => ({ value: v.name, label: v.name })),
//                 formData.village,
//               )}
//               onChange={(opt) => handleReactSelect("village", opt)}
//               placeholder="Select Village"
//               className={errors.village ? "is-invalid" : ""}
//             />

//             {errors.village && (
//               <div className="invalid-feedback d-block">{errors.village}</div>
//             )}
//           </div>

//           {/* Address */}
//           <div className="col-md-12 mb-3">
//             <label>
//               Address <span className="text-danger">*</span>
//             </label>
//             <textarea
//               name="address"
//               className={getInputClass("address")}
//               value={formData.address || ""}
//               onChange={handleChange}
//               onBlur={handleBlur}
//             />
//             {errors.address && (
//               <div className="invalid-feedback">{errors.address}</div>
//             )}
//           </div>
//           {/* Pincode */}
//           <div className="col-md-4 mb-3">
//             <label>
//               Pincode <span className="text-danger">*</span>
//             </label>
//             <input
//               name="pincode"
//               className={getInputClass("pincode")}
//               value={formData.pincode || ""}
//               onChange={handleChange}
//               onBlur={(e) => {
//                 const error = validateField("pincode", e.target.value);
//                 setErrors((prev) => ({ ...prev, pincode: error }));
//               }}
//             />

//             {errors.pincode && (
//               <div className="invalid-feedback">{errors.pincode}</div>
//             )}
//           </div>

//           {/* Website */}
//           <div className="col-md-4 mb-3">
//             <label>
//               Website <span className="text-danger">*</span>
//             </label>
//             <input
//               name="website"
//               className={getInputClass("website")}
//               value={formData.website || ""}
//               onChange={handleChange}
//               onBlur={(e) =>
//                 setErrors((prev) => ({
//                   ...prev,
//                   website: validateField("website", e.target.value),
//                 }))
//               }
//             />
//             {errors.website && (
//               <div className="invalid-feedback">{errors.website}</div>
//             )}
//           </div>
//           <div className="col-md-4 mb-3">
//             <label>
//               STD code <span className="text-danger">*</span>
//             </label>
//             <input
//               name="stdCode"
//               className={getInputClass("stdCode")}
//               value={formData.stdCode || ""}
//               onChange={handleChange}
//               maxLength={5}
//               onBlur={(e) =>
//                 setErrors((prev) => ({
//                   ...prev,
//                   stdCode: validateField("stdCode", e.target.value),
//                 }))
//               }
//             />
//             {errors.stdCode && (
//               <div className="invalid-feedback">{errors.stdCode}</div>
//             )}
//           </div>
//           {/* Phone */}
//           <div className="col-md-4 mb-3">
//             <label>
//               Tel.No <span className="text-danger">*</span>
//             </label>
//             <input
//               name="phone"
//               className={getInputClass("phone")}
//               value={formData.phone || ""}
//               onChange={handleChange}
//               onBlur={(e) =>
//                 setErrors((prev) => ({
//                   ...prev,
//                   phone: validateField("phone", e.target.value),
//                 }))
//               }
//             />

//             {errors.phone && (
//               <div className="invalid-feedback">{errors.phone}</div>
//             )}
//           </div>

//           <div className="col-md-4 mb-3">
//             <label>
//               Aadhaar Number <span className="text-danger">*</span>
//             </label>

//             <div className="d-flex gap-2">
//               <input
//                 name="aadhaarNumber"
//                 className={`form-control ${getInputClass("aadhaarNumber")}`}
//                 value={formData.aadhaarNumber || ""}
//                 onChange={handleChange}
//                 readOnly={aadhaarVerification.verified}
//                 onBlur={(e) =>
//                   setErrors((prev) => ({
//                     ...prev,
//                     aadhaarNumber: validateField(
//                       "aadhaarNumber",
//                       e.target.value,
//                     ),
//                   }))
//                 }
//               />

//               <button
//                 type="button"
//                 className="btn btn-sm btn-primary"
//                 disabled={
//                   !formData.aadhaarNumber ||
//                   errors.aadhaarNumber ||
//                   aadhaarVerification.verified
//                 }
//                 onClick={() => {
//                   if (isLocalEnvironment) {
//                     activateLocalAadhaarVerification();
//                     return;
//                   }

//                   setAadhaarVerification({
//                     show: true,
//                     verified: false,
//                     aadhaarnumber: formData.aadhaarNumber,
//                     verifiedAadhaar: "",
//                   });
//                 }}
//               >
//                 {aadhaarVerification.verified ? "Verified" : "Verify"}
//               </button>
//             </div>

//             {errors.aadhaarNumber && (
//               <div className="invalid-feedback d-block">
//                 {errors.aadhaarNumber}
//               </div>
//             )}
//           </div>

//           {/* Email */}
//           <div className="col-md-4 mb-3">
//             <label>
//               Email ID <span className="text-danger">*</span>
//             </label>

//             <div className="d-flex gap-2">
//               <input
//                 name="email"
//                 className={getInputClass("email")}
//                 value={formData.email || ""}
//                 readOnly={emailVerification.verified}
//                 onChange={async (e) => {
//                   const email = e.target.value;

//                   handleChange(e);

//                   const error = validateField("email", email);

//                   // Stop API call if validation fails
//                   if (error) {
//                     setErrors((prev) => ({
//                       ...prev,
//                       email: error,
//                     }));
//                     return;
//                   }

//                   try {
//                     const exists = await checkEmailExists(email.trim());
//                     setExists(exists);

//                     setErrors((prev) => ({
//                       ...prev,
//                       email: exists ? "This email is already registered." : "",
//                     }));
//                   } catch (err) {
//                     console.error("Email check failed:", err);
//                   }
//                 }}
//               />

//               <button
//                 type="button"
//                 className="btn btn-sm btn-primary"
//                 disabled={
//                   !formData.email ||
//                   errors.email ||
//                   exists ||
//                   emailVerification.verified
//                 }
//                 onClick={() => {
//                   if (isLocalEnvironment) {
//                     activateLocalEmailVerification();
//                     return;
//                   }

//                   setEmailVerification({
//                     show: true,
//                     verified: false,
//                     email: formData.email,
//                     verifiedEmail: "",
//                   });
//                 }}
//               >
//                 {emailVerification.verified ? "Verified" : "Verify"}
//               </button>
//             </div>

//             {errors.email && (
//               <div className="invalid-feedback d-block">{errors.email}</div>
//             )}
//           </div>

//           <div className="col-md-4 mb-3">
//             <label>
//               Name <span className="text-danger">*</span>
//             </label>
//             <input
//               name="creatorUserName"
//               className={getInputClass("creatorUserName")}
//               value={formData.creatorUserName || ""}
//               onChange={handleChange}
//               onBlur={(e) =>
//                 setErrors((prev) => ({
//                   ...prev,
//                   creatorUserName: validateField(
//                     "creatorUserName",
//                     e.target.value,
//                   ),
//                 }))
//               }
//               readOnly={aadhaarVerification.verifyName}
//             />

//             {errors.creatorUserName && (
//               <div className="invalid-feedback">{errors.creatorUserName}</div>
//             )}
//           </div>

//           <div className="col-md-4 mb-3">
//             <label>
//               Mobile Number <span className="text-danger">*</span>
//             </label>

//             <div className="d-flex gap-2">
//               <input
//                 name="mobileNumber"
//                 className={getInputClass("mobileNumber")}
//                 value={formData.mobileNumber || ""}
//                 onChange={handleChange}
//                 onBlur={(e) =>
//                   setErrors((prev) => ({
//                     ...prev,
//                     mobileNumber: validateField("mobileNumber", e.target.value),
//                   }))
//                 }
//               />

//               <button
//                 type="button"
//                 className="btn btn-sm btn-primary"
//                 disabled={
//                   !formData.mobileNumber ||
//                   errors.mobileNumber ||
//                   mobileNumberVerification.verified
//                 }
//                 onClick={() => {
//                   if (isLocalEnvironment) {
//                     activateLocalMobileVerification();
//                     return;
//                   }

//                   setMobileNumberVerification({
//                     show: true,
//                     verified: false,
//                     mobileNumber: formData.mobileNumber,
//                     verifiedMobileNumber: "",
//                   });
//                 }}
//               >
//                 {mobileNumberVerification.verified ? "Verified" : "Verify"}
//               </button>
//             </div>

//             {errors.mobileNumber && (
//               <div className="invalid-feedback d-block">
//                 {errors.mobileNumber}
//               </div>
//             )}
//           </div>

//           {/* Institute Type */}
//           <div className="col-md-4 mb-3">
//             <label>
//               Institute Type <span className="text-danger">*</span>
//             </label>

//             <Select
//               isSearchable
//               isClearable
//               name="instituteType"
//               options={instituteTypesList.map((t) => ({
//                 value: getPicklistLabel(t),
//                 label: getPicklistLabel(t),
//               }))}
//               value={getSelectValue(
//                 instituteTypesList.map((t) => ({
//                   value: getPicklistLabel(t),
//                   label: getPicklistLabel(t),
//                 })),
//                 formData.instituteType,
//               )}
//               onChange={(opt) => handleReactSelect("instituteType", opt)}
//               placeholder="Select Type"
//               className={errors.instituteType ? "is-invalid" : ""}
//             />

//             {errors.instituteType && (
//               <div className="invalid-feedback d-block">
//                 {errors.instituteType}
//               </div>
//             )}
//           </div>

//           {/* Registration Number */}
//           <div className="col-md-4 mb-3">
//             <label>
//               Institute Registration No. <span className="text-danger">*</span>
//             </label>
//             <input
//               name="regNumber"
//               className={getInputClass("regNumber")}
//               value={formData.regNumber || ""}
//               onChange={handleChange}
//               onBlur={handleBlur}
//             />
//             {errors.regNumber && (
//               <div className="invalid-feedback">{errors.regNumber}</div>
//             )}
//           </div>
//           {/* Establishment Year */}
//           <div className="col-md-4 mb-3">
//             <label>
//               Establishment Year <span className="text-danger">*</span>
//             </label>
//             <input
//               name="establishYear"
//               className={getInputClass("establishYear")}
//               value={formData.establishYear || ""}
//               onChange={handleChange}
//               onBlur={handleBlur}
//             />
//             {errors.establishYear && (
//               <div className="invalid-feedback">{errors.establishYear}</div>
//             )}
//           </div>

//           <div className="col-md-4 mb-3">
//             <label>
//               University Name <span className="text-danger">*</span>
//             </label>

//             <Select
//               isSearchable
//               isClearable
//               name="university"
//               options={universitiesList.map((u) => ({
//                 value: u.name,
//                 label: u.name,
//               }))}
//               value={getSelectValue(
//                 universitiesList.map((u) => ({ value: u.name, label: u.name })),
//                 formData.university,
//               )}
//               onChange={(opt) => handleReactSelect("university", opt)}
//               placeholder="Select University"
//               className={errors.university ? "is-invalid" : ""}
//             />

//             {errors.university && (
//               <div className="invalid-feedback d-block">
//                 {errors.university}
//               </div>
//             )}
//           </div>

//           <div className="col-md-4 mb-3">
//             <label>
//               Is Institute Under <span className="text-danger">*</span>
//             </label>
//             <Select
//               isSearchable
//               isClearable
//               name="instituteUnder"
//               options={instituteUnderList.map((t) => ({
//                 value: getPicklistLabel(t),
//                 label: getPicklistLabel(t),
//               }))}
//               value={getSelectValue(
//                 instituteUnderList.map((t) => ({
//                   value: getPicklistLabel(t),
//                   label: getPicklistLabel(t),
//                 })),
//                 formData.instituteUnder,
//               )}
//               onChange={(opt) => handleReactSelect("instituteUnder", opt)}
//               placeholder="Select Type"
//               className={errors.instituteUnder ? "is-invalid" : ""}
//               classNamePrefix="react-select"
//             />
//             {errors.instituteUnder && (
//               <div className="invalid-feedback">{errors.instituteUnder}</div>
//             )}
//           </div>
//           {/* NAAC Accredited */}
//           <div className="col-md-4 mb-3">
//             <label className="d-block mb-2">
//               National Assessment and Accreditation Council (NAAC)?{" "}
//               <span className="text-danger">*</span>
//             </label>

//             <div className="form-check form-check-inline">
//               <input
//                 type="radio"
//                 className="form-check-input"
//                 id="naacAccreditedYes"
//                 name="naacAccredited"
//                 checked={formData.naacAccredited === true}
//                 onChange={() => handleRadioChange("naacAccredited", true)}
//               />
//               <label className="form-check-label" htmlFor="naacAccreditedYes">
//                 Yes
//               </label>
//             </div>

//             <div className="form-check form-check-inline">
//               <input
//                 type="radio"
//                 className="form-check-input"
//                 id="naacAccreditedNo"
//                 name="naacAccredited"
//                 checked={formData.naacAccredited === false}
//                 onChange={() => handleRadioChange("naacAccredited", false)}
//               />
//               <label className="form-check-label" htmlFor="naacAccreditedNo">
//                 No
//               </label>
//             </div>

//             {errors.naacAccredited && (
//               <div className="invalid-feedback d-block">
//                 {errors.naacAccredited}
//               </div>
//             )}
//           </div>

//           <div className="col-md-4 mb-3">
//             <label className="d-block">
//               Is this institute under your administration/Department ?
//             </label>

//             <div className="form-check form-check-inline">
//               <input
//                 type="radio"
//                 className="form-check-input"
//                 name="underAdministration"
//                 checked={formData.underAdministration === true}
//                 onChange={() => handleRadioChange("underAdministration", true)}
//               />
//               <label className="form-check-label">Yes</label>
//             </div>

//             <div className="form-check form-check-inline">
//               <input
//                 type="radio"
//                 className="form-check-input"
//                 name="underAdministration"
//                 checked={formData.underAdministration === false}
//                 onChange={() => handleRadioChange("underAdministration", false)}
//               />
//               <label className="form-check-label">No</label>
//             </div>
//           </div>

//           <div className="col-md-4 mb-3">
//             <label>AICTE Approval</label>

//             <div>
//               <input
//                 type="file"
//                 name="aicteApprovalFiles"
//                 multiple
//                 accept=".pdf,application/pdf"
//                 className={`form-control ${errors.aicteApprovalFiles ? "is-invalid" : ""}`}
//                 onChange={handleFileUpload}
//               />

//               {errors.aicteApprovalFiles && (
//                 <div className="invalid-feedback d-block">
//                   {errors.aicteApprovalFiles}
//                 </div>
//               )}
//             </div>

//             {/* File List */}
//             {formData.aicteApprovalFiles?.length > 0 && (
//               <div className="mt-3">
//                 {formData.aicteApprovalFiles.map((file, index) => (
//                   <div
//                     key={index}
//                     className="d-flex justify-content-between align-items-center bg-white shadow-sm rounded-pill px-3 py-2 mb-2"
//                   >
//                     <span className="text-dark text-truncate">
//                       📄 {file.name}
//                     </span>

//                     <button
//                       type="button"
//                       className="btn btn-sm btn-light text-danger fw-bold"
//                       onClick={() =>
//                         handleRemoveFile("aicteApprovalFiles", index)
//                       }
//                     >
//                       ✖
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//           <div className="col-md-4 mb-3">
//             <label>
//               Authorization Letter <span className="text-danger">*</span>
//             </label>

//             <div>
//               <input
//                 type="file"
//                 name="authorizationLetterFiles"
//                 multiple
//                 accept=".pdf,application/pdf"
//                 className={`form-control ${errors.authorizationLetterFiles ? "is-invalid" : ""}`}
//                 onChange={handleFileUpload}
//               />

//               {errors.authorizationLetterFiles && (
//                 <div className="invalid-feedback d-block">
//                   {errors.authorizationLetterFiles}
//                 </div>
//               )}
//             </div>

//             {/* File List */}
//             {formData.authorizationLetterFiles?.length > 0 && (
//               <div className="mt-3">
//                 {formData.authorizationLetterFiles.map((file, index) => (
//                   <div
//                     key={index}
//                     className="d-flex justify-content-between align-items-center bg-white shadow-sm rounded-pill px-3 py-2 mb-2"
//                   >
//                     <span className="text-dark text-truncate">
//                       📄 {file.name}
//                     </span>

//                     <button
//                       type="button"
//                       className="btn btn-sm btn-light text-danger fw-bold"
//                       onClick={() =>
//                         handleRemoveFile("authorizationLetterFiles", index)
//                       }
//                     >
//                       ✖
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>

//           {formData.state &&
//             normalizeState(formData.state) !== "maharashtra" && (
//               <div className="col-md-4 mb-3">
//                 <div className="form-check">
//                   <input
//                     type="checkbox"
//                     className={`form-check-input ${errors.outsideMaharashtra ? "is-invalid" : ""
//                       }`}
//                     name="outsideMaharashtra"
//                     checked={formData.outsideMaharashtra || false}
//                     onChange={handleChange}
//                   />
//                   <label className="form-check-label">
//                     Institute is located outside Maharashtra{" "}
//                     <span className="text-danger">*</span>
//                   </label>

//                   {errors.outsideMaharashtra && (
//                     <div className="invalid-feedback d-block">
//                       {errors.outsideMaharashtra}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}
//         </div>

//         <div className="d-flex justify-content-between">
//           <button
//             className="btn btn-primary"
//             disabled={!canProceedWithoutOtp}
//             onClick={async () => {
//               const isValid = validateForm();

//               if (!isValid) return;
//               if (errors.email === "This email is already registered.") return;

//               nextStep();
//             }}
//           >
//             Next →
//           </button>
//         </div>
//       </div>
//     </>
//   );
// };
// const buildUserPayloadFromEmail = (formData) => {
//   const randomNumber = Math.floor(10000 + Math.random() * 90000);
//   const name = formData.instituteName.toLowerCase();
//   const firstWord = name.split(" ")[0];
//   const cleanName = name.replace(/\s+/g, "");
//   const randomLetters = Array.from(
//     { length: 6 },
//     () => cleanName[Math.floor(Math.random() * cleanName.length)],
//   ).join("");
//   const collegeNameFirstWord = firstWord + randomLetters;
//   const alternateName =
//     `${formData.deptCode}${randomNumber}_${collegeNameFirstWord}`.toLowerCase();
//   return alternateName;
// };

// /* =========================
//    STEP 3 – REVIEW
// ========================= */
// const ReviewSubmit = ({ formData, prevStep }) => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [showConfirmation, setShowConfirmation] = useState(false);
//   const [submittedApplicationNumber, setSubmittedApplicationNumber] =
//     useState("");
//   const handleSubmit = async () => {
//     setLoading(true);
//     setError(null);
//     const userId = window.Liferay.ThemeDisplay.getUserId();
//     const userData = await getUserRolesById(userId);
//     const userName = buildUserPayloadFromEmail(formData);

//     const roleIds =
//       userData?.roleBriefs
//         ?.filter((role) => role.name !== "User")
//         .map((role) => role.id) || [];

//     const mahaApplicationId = generateApplicationNumber();
//     // // Upload AICTE Files
//     // const uploadedAicteDocs = await uploadMultipleFiles(
//     //   formData.aicteApprovalFiles
//     // );

//     // // Upload Authorization Letter Files
//     // const uploadedAuthDocs = await uploadMultipleFiles (
//     //   formData.authorizationLetterFiles
//     // );
//     const [uploadedAicteDocs, uploadedAuthDocs] = await Promise.all([
//       uploadMultipleFiles(formData.aicteApprovalFiles),
//       uploadMultipleFiles(formData.authorizationLetterFiles),
//     ]);

//     console.log("department id  ...............",formData.departmentId);
//     const payload = {
//       creatorUserName: formData.creatorUserName,
//       mobileNumber: formData.mobileNumber,
//       aadhaarNumber: formData.aadhaarNumber,
//       address: formData.address,
//       aisheCode: formData.aisheCode,
//       // college code is missing
//       collegeContactNumber: formData.phone,
//       collegeEmailAddress: formData.email,
//       // college id is missing
//       // college registratio0n data missing
//       collegeRegistrationNo: formData.regNumber,
//       // college type id
//       collegeVerificationYear: formData.establishYear,
//       collegeType: formData.instituteType,
//       // depatment id missing
//       // parentDepartmentId:formData.parentDepartmentId,
//       departmentId: Number(formData.departmentId),
//       departmentCode: formData.departmentCode,
//       departmentAssignedCode: formData.deptCode,
//       departmentName: formData.parentDepartment,
//       districtId: formData.districtId,
//       mahaDbtCode: formData.mahaDbtCode,
//       mahaApplicationId: mahaApplicationId,
//       name: formData.instituteName,
//       namell: formData.instituteName,
//       pincode: formData.pincode,
//       r_districtCollege_c_districtId: formData.districtId,
//       r_talukaCollege_c_talukaId: formData.talukaId,
//       talukaId: formData.talukaId,
//       stateId: formData.stateId,
//       villageId: formData.villageId,
//       website: formData.website,
//       underAdministration: formData.underAdministration,
//       stdCode: formData.stdCode,
//       universityName: formData.university,
//       instituteUnder: formData.instituteUnder,
//       naacAccredited: formData.naacAccredited,
//       outsideMaharashtra: formData.outsideMaharashtra,
//       aicteApproval: uploadedAicteDocs.map((doc) => ({
//         documentId: doc.documentId,
//         name: doc.title,
//         url: doc.downloadURL,
//       })),

//       authorizationLetter: uploadedAuthDocs.map((doc) => ({
//         documentId: doc.documentId,
//         name: doc.title,
//         url: doc.downloadURL,
//       })),
//     };

//     try {
//       const data = await creatingEntry(payload);
//       const finalApplicationNumber =
//         data?.mahaApplicationId || mahaApplicationId;
//       setSubmittedApplicationNumber(finalApplicationNumber);
//       setShowConfirmation(true);
//       console.log("API Response:", data);
//     } catch (err) {
//       setError(err.message || "Something went wrong while submitting.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="card p-4 shadow-sm">
//       {/* Header */}
//       <h5 className="fw-bold mb-2 d-flex align-items-center">
//         Review Application Details
//       </h5>

//       <p className="text-muted mb-3">
//         Please review all the information before submitting. You can go back to
//         edit any details.
//       </p>

//       {/* Review Table */}
//       <table className="table table-bordered align-middle">
//         <tbody>
//           <tr>
//             <td className="fw-semibold">Parent Department</td>
//             <td>{formData.parentDepartment}</td>
//           </tr>
//           <tr>
//             <td className="fw-semibold">Department Assigned Code</td>
//             <td>{formData.deptCode}</td>
//           </tr>
//           <tr>
//             <td className="fw-semibold">
//               Institute / AISHE Code (All India Survey on Higher Education)
//             </td>
//             <td>{formData.aisheCode}</td>
//           </tr>
//           {/* <tr>
//             <td className="fw-semibold">Maha DBT Code</td>
//             <td>{formData.mahaDbtCode}</td>
//           </tr> */}

//           <tr>
//             <td className="fw-semibold">Institute Name / School Name</td>
//             <td>{formData.instituteName}</td>
//           </tr>
//           <tr>
//             <td className="fw-semibold">Address</td>
//             <td>{formData.address}</td>
//           </tr>
//           <tr>
//             <td className="fw-semibold">Website</td>
//             <td>{formData.website}</td>
//           </tr>
//           <tr>
//             <td className="fw-semibold">Email ID</td>
//             <td>{formData.email}</td>
//           </tr>
//           <tr>
//             <td className="fw-semibold">Tel.No</td>
//             {/* <td>{formData.phone}</td> */}
//             <td>{formData.stdCode}-{formData.phone}</td>
//           </tr>
//           <tr>
//             <td className="fw-semibold">Aadhaar Number</td>
//             <td>{formData.aadhaarNumber}</td>
//           </tr>
//           <tr>
//             <td className="fw-semibold">Name</td>
//             <td>{formData.creatorUserName}</td>
//           </tr>
//           <tr>
//             <td className="fw-semibold">Mobile Number </td>
//             <td>{formData.mobileNumber}</td>
//           </tr>
//           <tr>
//             <td className="fw-semibold">Institute Type</td>
//             <td>{formData.instituteType}</td>
//           </tr>
//           <tr>
//             <td className="fw-semibold">Institute Registration No.</td>
//             <td>{formData.regNumber}</td>
//           </tr>
//           <tr>
//             <td className="fw-semibold">NAAC Accredited</td>
//             <td>{formData.naacAccredited ? "Yes" : "No"}</td>
//           </tr>
//           {/* <tr>
//             <td className="fw-semibold">Establishment Year</td>
//             <td>{formData.establishYear}</td>
//           </tr> */}
//           {/* <tr>
//             <td className="fw-semibold">University Name</td>
//             <td>{formData.university}</td>
//           </tr> */}
//           <tr>
//             <td className="fw-semibold">Institute Under</td>
//             <td>{formData.instituteUnder}</td>
//           </tr>
//           <tr>
//             <td className="fw-semibold">Outside Maharashtra</td>
//             <td>{formData.outsideMaharashtra ? "Yes" : "No"}</td>
//           </tr>
//           {/* <tr>
//             <td className="fw-semibold">Parent Department</td>
//             <td>{formData.parentDepartment}</td>
//           </tr> */}

//           <tr>
//             <td className="fw-semibold">Village</td>
//             <td>{formData.village}</td>
//           </tr>

//           {/* <tr>
//             <td className="fw-semibold">STD Code</td>
//             <td>{formData.stdCode}</td>
//           </tr> */}

//           {/* <tr>
//             <td className="fw-semibold">Registration Number</td>
//             <td>{formData.regNumber}</td>
//           </tr> */}

//           <tr>
//             <td className="fw-semibold">Establishment Year</td>
//             <td>{formData.establishYear}</td>
//           </tr>

//           <tr>
//             <td className="fw-semibold">University Name</td>
//             <td>{formData.university}</td>
//           </tr>

//           <tr>
//             <td className="fw-semibold">Institute Under</td>
//             <td>{formData.instituteUnder}</td>
//           </tr>
//           <tr>
//             <td className="fw-semibold">Under Administration / Department</td>
//             <td>
//               {formData.underAdministration === null
//                 ? "-"
//                 : formData.underAdministration
//                   ? "Yes"
//                   : "No"}
//             </td>
//           </tr>
//           <tr>
//             <td className="fw-semibold">AICTE Approval</td>
//             <td>
//               {formData.aicteApprovalFiles?.map((file, i) => (
//                 <div key={i}>{file.name}</div>
//               ))}
//             </td>
//           </tr>

//           <tr>
//             <td className="fw-semibold">Authorization Letter</td>
//             <td>
//               {formData.authorizationLetterFiles?.map((file, i) => (
//                 <div key={i}>{file.name}</div>
//               ))}
//             </td>
//           </tr>
//         </tbody>
//       </table>

//       {/* Important Info */}
//       <div className="alert alert-info mt-3">
//         <strong>Important:</strong> Once submitted, you cannot edit the
//         application. Please ensure all details are correct.
//       </div>

//       {/* Buttons */}
//       <div className="d-flex justify-content-between mt-4">
//         <button className="btn btn-primary" onClick={prevStep}>
//           ← Previous
//         </button>
//         <button
//           className="btn btn-primary px-4"
//           onClick={handleSubmit}
//           disabled={loading}
//         >
//           {loading ? "Submitting..." : "Submit Application"}
//         </button>
//       </div>
//       {showConfirmation && (
//         <Confirmation applicationNumber={submittedApplicationNumber} />
//       )}
//     </div>
//   );
// };

// const generateApplicationNumber = () => {
//   const year = new Date().getFullYear();
//   const random = Math.floor(10000 + Math.random() * 90000);
//   return `MAH-${year}-${random}`;
// };

// /* =========================
//    STEP 4 – CONFIRMATION
// ========================= */
// const Confirmation = ({ applicationNumber }) => {
//   return (
//     <>
//       <div
//         className="modal-backdrop fade show"
//         style={{ backgroundColor: "rgba(0,0,0,0.35)" }}
//       />
//       <div
//         className="modal fade show d-block"
//         tabIndex="-1"
//         role="dialog"
//         aria-modal="true"
//       >
//         <div className="modal-dialog modal-dialog-centered" role="document">
//           <div className="modal-content border-0 shadow rounded-4">
//             <div className="modal-body text-center p-4">
//               <h5 className="text-primary fw-bold mb-2">
//                 Application Submitted Successfully
//               </h5>
//               <p className="text-muted mb-3">
//                 Your institute onboarding form has been submitted.
//               </p>

//               <div className="alert alert-primary py-2 mb-3">
//                 Application Number <strong>{applicationNumber}</strong>
//               </div>

//               <button
//                 className="btn btn-primary px-4"
//                 onClick={() => (window.location.href = "/home")}
//               >
//                 Go to Home
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };
